import React, { Component } from "react";
import { connect } from "react-redux";
import Datetime from "react-datetime";
import { Column, Row } from "@sm/helpers/simple-flexbox";
import { Panel } from "react-bootstrap";

import DebitCreditComponent from "@modules/data/components/DebitCreditComponent";
import CustomButton from "@sm/components/custom/Button";
import Form from "@sm/core/Form";
import FormRow from "@modules/data/components/FormRow";
import Multiselect from "@sm/components/custom/customMultiselect";
import OtcCashoutComponent from "@modules/data/components/OtcCashoutComponent";
import PayoutTopUpComponent from "@modules/data/components/PayoutTopUpComponent";
import OtcCashoutUpdateComponent from "@modules/data/components/OtcCashoutUpdateComponent";
import OtcSettlementComponent from "@modules/data/components/OtcSettlementComponent";
import OtcWithdrawalComponent from "@modules/data/components/OtcWithdrawalComponent";
import OtcWithdrawalByRequestComponent from "@modules/data/components/OtcWithdrawalByRequestComponent";
import OtcSettlementByRequestComponent from "@modules/data/components/OtcSettlementByRequestComponent";
import PageHeader from "@sm/components/PageHeader";
import PromptModal from "../generateReport/PromptModal";
import RunningBalanceComponent from "@modules/data/components/RunningBalanceComponent";
import Select from "@sm/components/custom/Select";
import SettleAgentComponent from "@modules/data/components/SettleAgentComponent";
import SettlementByAmountComponent from "@modules/data/components/SettlementByAmountComponent";
import SettlementByDateComponent from "@modules/data/components/SettlementByDateComponent";
import SettlementByRequestComponent from "@modules/data/components/SettlementByRequestComponent";
import Spinner from "@sm/components/Spinner";
import TopUpPayoutWalletComponent from "@modules/data/components/TopUpPayoutWalletComponent";
import TopUpByRequestComponent from "@modules/data/components/TopUpByRequestComponent";
import UpdateSettlementComponent from "@modules/data/components/UpdateSettlementComponent";
import WithheldFundsComponent from "@modules/data/components/WithheldFundsComponent";

import "@assets/css/manualInput.css";
import ManualInputIcon from "@assets/images/notes.png";

import * as actions from "@sm/actions";
import { crudActions } from "@sm/services/crudActions";
import { FETCH_PERMISSIONS } from "@sm/actions/types";
import { dateToNumber, isSingleElementArray } from "@sm/utils/utils";

const store = require("@sm/reducers/index");

export const DATA_TYPES = {
  DEBIT_CREDIT:                    "DEBIT_CREDIT",
  OTC_CASHOUT:                     "OTC_CASHOUT",
  OTC_CASHOUT_UPDATE:              "OTC_CASHOUT_UPDATE",
  OTC_SETTLEMENT:                  "OTC_SETTLEMENT",
  OTC_SETTLEMENT_BY_REQUEST:       "OTC_SETTLEMENT_BY_REQUEST",
  OTC_WITHDRAWAL:                  "OTC_WITHDRAWAL",
  OTC_WITHDRAWAL_BY_REQUEST:       "OTC_WITHDRAWAL_BY_REQUEST",
  PAYOUT_TOP_UP:                   "PAYOUT_TOP_UP",
  RUNNING_BALANCE:                 "RUNNING_BALANCE",
  SETTLE_AGENT:                    "SETTLE_AGENT",
  SETTLEMENT_BY_AMOUNT:            "SETTLEMENT_BY_AMOUNT",
  SETTLEMENT_BY_DATE:              "SETTLEMENT_BY_DATE",
  SETTLEMENT_BY_REQUEST:           "SETTLEMENT_BY_REQUEST",
  TOP_UP_PAYOUT_WALLET:            "TOP_UP_PAYOUT_WALLET",
  TOP_UP_PAYOUT_WALLET_BY_REQUEST: "TOP_UP_PAYOUT_WALLET_BY_REQUEST",
  UPDATE_SETTLEMENT:               "UPDATE_SETTLEMENT",
  WITHHELD_FUNDS:                  "WITHHELD_FUNDS"
};

class ManualInput extends Component {
  dataTypeComponentRef = React.createRef();
  
  fieldsMap = {
    [DATA_TYPES.DEBIT_CREDIT]: [],
    [DATA_TYPES.OTC_CASHOUT]: [],
    [DATA_TYPES.OTC_CASHOUT_UPDATE]: [],
    [DATA_TYPES.OTC_SETTLEMENT]: [],
    [DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST]: [],
    [DATA_TYPES.OTC_WITHDRAWAL]: [],
    [DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST]: [],
    [DATA_TYPES.PAYOUT_TOP_UP]: [],
    [DATA_TYPES.RUNNING_BALANCE]: [],
    [DATA_TYPES.SETTLE_AGENT]: [],
    [DATA_TYPES.SETTLEMENT_BY_AMOUNT]: [],
    [DATA_TYPES.SETTLEMENT_BY_DATE]: [],
    [DATA_TYPES.SETTLEMENT_BY_REQUEST]: [],
    [DATA_TYPES.TOP_UP_PAYOUT_WALLET]: [],
    [DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST]: [],
    [DATA_TYPES.UPDATE_SETTLEMENT]: [],
    [DATA_TYPES.WITHHELD_FUNDS]: []
  };

  formsMap = {
    [DATA_TYPES.DEBIT_CREDIT]: "debitCreditForm",
    [DATA_TYPES.OTC_CASHOUT]: "otcCashoutForm",
    [DATA_TYPES.OTC_CASHOUT_UPDATE]: "otcCashoutUpdateForm",
    [DATA_TYPES.OTC_SETTLEMENT]: "otcSettlementForm",
    [DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST]: "otcSettlementFormByRequest",
    [DATA_TYPES.OTC_WITHDRAWAL]: "otcWithdrawalForm",
    [DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST]: "otcWithdrawalByRequestForm",
    [DATA_TYPES.PAYOUT_TOP_UP]: "payoutTopUpForm",
    [DATA_TYPES.RUNNING_BALANCE]: "runningBalanceForm",
    [DATA_TYPES.SETTLE_AGENT]: "settleAgentForm",
    [DATA_TYPES.SETTLEMENT_BY_AMOUNT]: "settlementFormByAmount",
    [DATA_TYPES.SETTLEMENT_BY_DATE]: "settlementFormByDate",
    [DATA_TYPES.SETTLEMENT_BY_REQUEST]: "settlementFormByRequest",
    [DATA_TYPES.TOP_UP_PAYOUT_WALLET]: "topUpPayoutWalletForm",
    [DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST]: "topUpPayoutWalletByRequestForm",
    [DATA_TYPES.UPDATE_SETTLEMENT]: "updateSettlementForm",
    [DATA_TYPES.WITHHELD_FUNDS]: "withdheldFundsForm"
  };

  state = {
    runningBalanceTypes: [],
    runningBalanceValues: [],
    settlementStatuses: [],
    settlementByAmountStatuses: [],
    otcSettlementStatuses: [],
    settlementByRequestStatuses: [],
    updateSettlementStatuses: [],
    midsForDebit: [],
    midsForCredit: [],
    creditPsps: [],
    settlementDates: [],
    settlementsByDate: [],

    settlementFormByDate: [],
    settlementFormByAmount: [],
    settlementFormByRequest: [],

    debitCreditForm: [],
    otcCashoutForm : [],
    otcCashoutUpdateForm : [],
    otcCashoutInvoiceDates: [],
    invoices: [],
    otcCashoutInvoiceFullInfo: [],
    filteredFxPairs: [],

    date: Datetime.moment().utc(),
    lastUpdate: Datetime.moment().format("HH:mm - DD. MMM YYYY"),
    lastSettlementDate: "",
    loadingLookups: true,
    loadingDataInput: false,

    controls: {},
    controlsFormRules: [
      {
        name: "company",
        type: "isString",
        rules: {
          required: true,
        },
      },
      {
        name: "merchant",
        type: "isString",
        rules: {
          required: true,
        },
      },
      {
        name: "dataType",
        type: "isString",
        rules: {
          required: true,
        },
      }
    ],
    controlsFormData: {
      company: "",
      merchant: "",
      dataType: "",
      psp: "",
      midIds: "",
      settlementStatus: "",
      date: "",
    },

    companiesClients: {},
    companiesPsps: {},
    companiesAccounts: {},
    companiesFxPairs: {},
    companiesBaseCurrencies: {},
    companiesRBChangesAllowed: {},
    companiesWalletCurrencies: {},
    companies: [],
    otcActionType: [{
      value: DATA_TYPES.OTC_CASHOUT,
      label: "Collect"
    }, {
      value: DATA_TYPES.OTC_CASHOUT_UPDATE,
      label: "Update Status"
    }, {
      value: DATA_TYPES.PAYOUT_TOP_UP,
      label: "Payout Top Up"
    }],
    otcSettlementsActionType: [{
      value: DATA_TYPES.OTC_SETTLEMENT,
      label: "OTC Settlement"
    }, {
      value: DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST,
      label: "OTC Settlement by Request"
    }, {
      value: DATA_TYPES.OTC_WITHDRAWAL,
      label: "OTC Withdrawal"
    }, {
      value: DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST,
      label: "OTC Withdrawal by Request"
    }],
    psps: [],
    mids: [],
    payoutMids: [],
    dataTypes: [],

    otcCashoutCurrencies: [],
    otcBalances: [],

    temporaryRunningBalanceItem: {},
    temporaryWithheldItem: {},
    savedData: {},

    settlementMids: [],
    otcCashoutStatuses: [],

    access: [],
    pageType: "settlements",
    submitClicked: false,
    saveClicked: false,
    lockButton: false,
    showSecondPanel: false,
    showThirdPanel: false,
    showPromptModal: false,
    promptMessage: ""
  };

  subscribeFunction = null;

  componentDidMount() {
    const { controlsFormRules, controlsFormData } = this.state;
    const { match } = this.props;

    const isIncomingFunds = match && match.path === "/inbound-settlement";
    const isOtcSettlements = match && match.path === "/otc-settlements";
    if (isIncomingFunds) {
      const merchantField = controlsFormRules.find(item => item.name === "merchant");
      merchantField.rules.required = false;
    }

    const propsState = this.props.location.state;
    let dataType;
    if (propsState && Object.keys(propsState).length > 0) {
      dataType = propsState.dataType;
    }
    this.setState({
      controls: dataType ? this.defineControlsForm(dataType) : isIncomingFunds ? this.defineControlsForm(DATA_TYPES.OTC_CASHOUT) : isOtcSettlements ? this.defineControlsForm(DATA_TYPES.OTC_SETTLEMENT) : new Form(controlsFormData, controlsFormRules),
      loading: false,
      timeStamp: Datetime.moment().utc(),
      pageType: isIncomingFunds ? "incomingFunds" : isOtcSettlements ? "otcSettlements" : "settlements",
      isOtcSettlements: isOtcSettlements
    });

    const storeState = store.default.getState().authReducer;
    if (storeState.access) {
      this.setState({
        access: storeState.access
      });
    }

    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().authReducer;

      if (state.userUpdate === FETCH_PERMISSIONS) {
        this.setState({
          access: state.access,
        });
      }
    });

    Promise.all([
      crudActions.get("v1/data/input/lookups"),
      crudActions.get("v1/agent/all")
    ]).then((info) => {
      const data = info[0];
      const agents = info[1];

      if (data) {
        if(!isIncomingFunds) {
          data.dataTypes = data.dataTypes.filter(elem => elem.id !== DATA_TYPES.OTC_CASHOUT && elem.id !== DATA_TYPES.OTC_CASHOUT_UPDATE && elem.id !== DATA_TYPES.PAYOUT_TOP_UP);
        }
        if (isIncomingFunds || isOtcSettlements) {
          data.whiteLabels = data.whiteLabels.filter(comp => comp.otcEnabled);
        }
        const companies = data.whiteLabels.map((elem) => elem.whitelabel);
        companies.sort((elemA, elemB) =>
          elemA.label.localeCompare(elemB.label)
        );
        const runningBalanceTypes = data.dataTypes.find(
          (elem) => elem.id === DATA_TYPES.RUNNING_BALANCE
        )?.properties;
        const settlementStatuses = data.dataTypes.find(
          (elem) => elem.id === DATA_TYPES.SETTLEMENT_BY_DATE
        ).properties;

        const otcCashoutStatuses = isIncomingFunds ? data.dataTypes.find(
          (elem) => elem.id === DATA_TYPES.OTC_CASHOUT
        ).properties : [];
        otcCashoutStatuses.push({
          value: "PAYOUT_TOP_UP",
          label: "Payout Top-up"
        });
        const midCurrency = data.mids.map((mid) => {
          return {
            value: mid.id,
            label: mid.currency,
          };
        });
        const uniqueCurrencies = [];

        const currency = midCurrency.filter((element) => {
          const isDuplicate = uniqueCurrencies.includes(element.label);

          if (!isDuplicate) {
            uniqueCurrencies.push(element.label);

            return true;
          }

          return false;
        });

        this.setState({
          companies: companies,
          controls: Object.assign(this.state.controls, {
            company: companies[0] ? companies[0].value : "",
          }),
          companiesClients: data.whiteLabels.reduce(
            (accumulator, currentElem) => {
              accumulator[currentElem.whitelabel.value] =
                isIncomingFunds || isOtcSettlements ? currentElem.merchants.filter(elem => elem.otcEnabled) : currentElem.merchants;
              return accumulator;
            },
            {}
          ),
          companiesPsps: data.whiteLabels.reduce(
            (accumulator, currentElem) => {
              accumulator[currentElem.whitelabel.value] = currentElem.psp;
              return accumulator;
            },
            {}
          ),
          companiesAccounts: data.whiteLabels.reduce(
            (accumulator, currentElem) => {
              accumulator[currentElem.whitelabel.value] = currentElem.pspAccounts || [];
              accumulator[currentElem.whitelabel.value] = accumulator[currentElem.whitelabel.value] ? accumulator[currentElem.whitelabel.value].map(({ id: value, name: label, ...rest }) => ({
                value,
                label,
                ...rest
              })) : [];
              return accumulator;
            },
            {}
          ),
          companiesFxPairs: data.whiteLabels.reduce(
            (accumulator, currentElem) => {
              accumulator[currentElem.whitelabel.value] = currentElem.fxPairs || [];
              return accumulator;
            },
            {}
          ),
          companiesBaseCurrencies: data.whiteLabels.reduce(
            (accumulator, currentElem) => {
              accumulator[currentElem.whitelabel.value] =
                  currentElem.baseCurrencies.map((elem) => ({
                    value: elem,
                    label: elem,
                  }));
              return accumulator;
            },
            {}
          ),
          companiesWalletCurrencies: data.whiteLabels.reduce(
            (accumulator, currentElem) => {
              accumulator[currentElem.whitelabel.value] = 
                  currentElem.walletCurrencies?.map((elem) => ({
                    value: elem.value,
                    label: elem.label,
                  }));
              return accumulator;
            },
            {}
          ),
          companiesRBChangesAllowed: data.whiteLabels.reduce(
            (accumulator, currentElem) => {
              accumulator[currentElem.whitelabel.value] = currentElem.manualRBChangesEnabled;
              return accumulator;
            },
            {}
          ),
          mids: data.mids.map((mid) => {
            return {
              value: mid.id,
              label: `${mid.name} (${mid.id})`,
              clients: mid.clients,
              pspId: mid.pspId,
              currency: mid.currency,
              method: mid.method
            };
          }),
          payoutMids: data.payoutMids.map((mid) => {
            return {
              value: mid.id,
              label: `${mid.name} (${mid.id})`,
              clients: mid.clients,
              pspId: mid.pspId,
              currency: mid.currency,
              method: mid.method
            };
          }),
          runningBalanceTypes: runningBalanceTypes,
          settlementStatuses: settlementStatuses,
          otcCashoutStatuses: otcCashoutStatuses,
          settlementByAmountStatuses: settlementStatuses.filter(
            (elem) => elem.label === "Settled"
          ),
          otcSettlementStatuses: settlementStatuses.filter(
            (elem) => elem.label === "Settled" || elem.value === "33"
          ),
          settlementByRequestStatuses: settlementStatuses.filter(
            (elem) => elem.label !== "Requested"
          ),
          otcSettlementByRequestStatuses: settlementStatuses.filter(
            (elem) => elem.label !== "Requested"
          ),
          updateSettlementStatuses: settlementStatuses.filter(
            (elem) => elem.label !== "Requested"
          ),
          dataTypes: data.dataTypes.map((elem) => {
            return {
              value: elem.id,
              label: elem.name,
              supportedBy: elem.supportedBy
            };
          }),
          agents: agents,
          loadingLookups: false,
          currency: currency,
        }, () => {
          const { state } = this.props.location;
          if (state && Object.keys(state).length > 0) {
            this.autoPopulateSettlement(state);
          }
        });
      }
    })
      .catch((err) => {
        if (err && err.message) {
          this.props.showAlert(true, "error", err.message);
        }
      });
  }

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  }

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  handleDateChange = (event) => {
    this.setState({ date: event });
  };

  defineControlsForm = (dataType) => {
    const { controls, controlsFormRules } = this.state;

    const copyArray = (arr) => {
      return JSON.parse(JSON.stringify(arr));
    };

    const runningBalanceForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || "",
      psp: "",
      midIds: "",
      updateSettlementDate: "",
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "psp",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "midIds",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "updateSettlementDate",
          type: "isString",
          rules: {
            required: false,
          },
        },
      ]
    ));

    const settlementByAmountForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || "",
      currency: "",
      psp: [],
      midIds: [],
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "psp",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "midIds",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        },
      ]
    ));

    const settlementByDateForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || "",
      date: Datetime.moment().format("DD.MM.YYYY"),
      currency: "",
      psp: [],
      midIds: [],
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "date",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "psp",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "midIds",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        },
      ]
    ));

    const settlementByRequestForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || "",
      currency: "",
      midIds: [],
      updateSettlementDate: "",
      settlementId: "",
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "midIds",
          type: "isArray",
          rules: {
            required: true,
          },
        },
        {
          name: "updateSettlementDate",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "settlementId",
          type: "isString",
          rules: {
            required: true,
          },
        }
      ]
    ));

    const otcSettlementByRequestForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || "",
      currency: "",
      midIds: [],
      updateSettlementDate: "",
      settlementId: ""
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "midIds",
          type: "isArray",
          rules: {
            required: true,
          },
        },
        {
          name: "updateSettlementDate",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "settlementId",
          type: "isString",
          rules: {
            required: true,
          },
        },
      ]
    ));

    const otcSettlementForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || DATA_TYPES.OTC_SETTLEMENT,
      fxPair: controls.fxPair || "",
      currency: "",
      psp: [],
      midIds: [],
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "fxPair",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "psp",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "midIds",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        },
      ]
    ));

    const otcWithdrawalForm = new Form({
      company: controls.company || "",
      merchant: "",
      dataType: controls.dataType || "",
      currency: "",
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
      ]
    ));

    const updateSettlementForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || "",
      settlementStatus: "",
      currency: "",
      midIds: [],
      updateSettlementDate: "",
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "settlementStatus",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "midIds",
          type: "isArray",
          rules: {
            required: true,
          },
        },
        {
          name: "updateSettlementDate",
          type: "isString",
          rules: {
            required: true,
          },
        },
      ]
    ));

    const topUpPayoutWalletForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || "",
      psp: "",
      midIds: "",
      updateSettlementDate: "",
      date: controls.date || ""
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "psp",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "midIds",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "updateSettlementDate",
          type: "isString",
          rules: {
            required: false,
          },
        },
      ]
    ));

    const topUpPayoutWalletByRequestForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant ? [controls.merchant] : [],
      dataType: controls.dataType || "",
      currency: "",
      id: null
    }, copyArray(controlsFormRules).map(rule => {
      if (rule.name === "merchant") {
        rule.type = "isArray";
      }
      return rule;
    }).concat(
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "id",
          type: "isNumber",
        }
      ]
    ));

    const withheldFundsForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || "",
      psp: "",
      midIds: "",
      updateSettlementDate: "",
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "psp",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "midIds",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "updateSettlementDate",
          type: "isString",
          rules: {
            required: false,
          },
        },
      ]
    ));

    const settleAgent = new Form({
      company: controls.company || "",
      dataType: controls.dataType || "",
      agent: controls.agent || "",
      date: this.state.timeStamp
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "date",
          type: "isDate",
          rules: {
            required: true,
          },
        },
        {
          name: "agent",
          type: "isString",
          rules: {
            required: true,
          },
        },
      ]
    ).map(el => el.name === "merchant" ? { ...el, rules: { required: false } } : el));

    const debitCreditForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant || "",
      dataType: controls.dataType || "",
      currency: "",
      psp: controls.psp || "",
      date: Datetime.moment().format("DD.MM.YYYY"),
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        }, {
          name: "psp",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "date",
          type: "isString",
          rules: {
            required: true,
          },
        },
      ]
    ));

    const otcCashoutForm = new Form({
      company: controls.company || "",
      dataType: controls.dataType || DATA_TYPES.OTC_CASHOUT,
      actionType: controls.dataType || DATA_TYPES.OTC_CASHOUT,
      psp: controls.psp || [],
      currency: controls.currency || "",
      fxPair: "",
      accountIds: controls.accountIds || [],
      date: Datetime.moment().format("DD.MM.YYYY"),
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "actionType",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "psp",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "fxPair",
          type: "isString",
          rules: {
            required: true,
          },
        }, {
          name: "accountIds",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        }, {
          name: "date",
          type: "isString",
          rules: {
            required: true,
          },
        },
      ]
    ));

    const payoutTopUpForm = new Form({
      company: controls.company || "",
      dataType: controls.dataType || DATA_TYPES.PAYOUT_TOP_UP,
      actionType: controls.dataType || DATA_TYPES.PAYOUT_TOP_UP,
      psp: controls.psp || [],
      currency: controls.currency || "",
      accountIds: controls.accountIds || [],
      date: Datetime.moment().format("DD.MM.YYYY"),
    }, copyArray(controlsFormRules).concat(
      [
        {
          name: "actionType",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "psp",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "accountIds",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        }, {
          name: "date",
          type: "isString",
          rules: {
            required: true,
          },
        },
      ]
    ));

    const otcCashoutUpdateFieldsBase = {
      company: controls.company || "",
      dataType: controls.dataType || DATA_TYPES.OTC_CASHOUT_UPDATE,
      actionType: controls.dataType || DATA_TYPES.OTC_CASHOUT_UPDATE,
      currency:  "",
      psp: [],
      accountIds: "",
      date: "",
    };

    const otcCashoutUpdateForm = new Form(otcCashoutUpdateFieldsBase, copyArray(controlsFormRules).concat(
      [
        {
          name: "actionType",
          type: "isString",
          rules: {
            required: true,
          },
        }, {
          name: "psp",
          type: "isArray",
          rules: {
            min: 1,
            required: true,
          },
        }, {
          name: "accountIds",
          type: "isArray",
          rules: {
            required: true,
          },
        },
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        }, {
          name: "date",
          type: "isString",
          rules: {
            required: true,
          },
        },
      ]
    ));

    const otcWithdrawalByRequestForm = new Form({
      company: controls.company || "",
      merchant: controls.merchant ? [controls.merchant] : [],
      dataType: controls.dataType || "",
      currency: "",
      id: null
    }, copyArray(controlsFormRules).map(rule => {
      if (rule.name === "merchant") {
        rule.type = "isArray";
        rule.rules = {
          ...rule.rules,
          min: 1
        };
      }
      return rule;
    }).concat(
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "id",
          type: "isString",
        }
      ]
    ));

    return dataType === DATA_TYPES.RUNNING_BALANCE ? runningBalanceForm :
      dataType === DATA_TYPES.SETTLEMENT_BY_AMOUNT ? settlementByAmountForm :
        dataType === DATA_TYPES.SETTLEMENT_BY_DATE ? settlementByDateForm :
          dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET ? topUpPayoutWalletForm :
            dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST ? topUpPayoutWalletByRequestForm :
              dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST ? settlementByRequestForm :
                dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST ? otcSettlementByRequestForm :
                  dataType === DATA_TYPES.OTC_SETTLEMENT ? otcSettlementForm :
                    dataType === DATA_TYPES.OTC_WITHDRAWAL ? otcWithdrawalForm :
                      dataType === DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST ? otcWithdrawalByRequestForm :
                        dataType ===DATA_TYPES.SETTLE_AGENT ? settleAgent :
                          dataType === DATA_TYPES.DEBIT_CREDIT ? debitCreditForm :
                            dataType === DATA_TYPES.WITHHELD_FUNDS ? withheldFundsForm :
                              dataType === DATA_TYPES.OTC_CASHOUT ? otcCashoutForm :
                                dataType === DATA_TYPES.OTC_CASHOUT_UPDATE ? otcCashoutUpdateForm :
                                  dataType === DATA_TYPES.PAYOUT_TOP_UP ? payoutTopUpForm : updateSettlementForm;
  };

  onValueChange = (event, field, isAutoRequest) => {
    const { controls, submitClicked, companiesAccounts, companiesBaseCurrencies, companiesFxPairs, companiesClients, companiesPsps, otcCashoutInvoiceFullInfo } = this.state;
    if (!event) {
      controls[field] = event;
    } else if (event.target) {
      controls[field] = event.target.value;
    } else if (event.value) {
      if (field === "midIds" && (controls.dataType === DATA_TYPES.RUNNING_BALANCE || controls.dataType === DATA_TYPES.WITHHELD_FUNDS)) {
        controls[field] = event.value.toString();
      } else {
        controls[field] = event.value;
      }
    } else {
      controls[field] = event.map((elem) => elem.value);
    }

    const pspField = controls.fieldRules.find(
      (fieldRule) => fieldRule.name === "psp"
    );
    const midIdsField = controls.fieldRules.find(
      (fieldRule) => fieldRule.name === "midIds"
    );

    if (field === "company") {
      controls.merchant = "";
      controls.psp = pspField && pspField.type === "isArray" ? [] : "";
      controls.midIds = midIdsField && midIdsField.type === "isArray" ? [] : "";
    } else if (field === "merchant") {
      controls.psp = pspField && pspField.type === "isArray" ? [] : "";
      controls.midIds = midIdsField && midIdsField.type === "isArray" ? [] : "";
      if (controls.dataType === DATA_TYPES.OTC_SETTLEMENT || controls.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) {
        this.loadSettlementFeeData(controls[field]);
        const merchantFxPairs = companiesClients[controls.company].find(client => client.value === controls.merchant).fxPairs || [];
        const fxPairs = merchantFxPairs.filter(elem =>  elem.split("/")[1] === controls.currency).map((pair) => {
          return { value: pair, label: this.getFxPairValue(pair)};
        });
        fxPairs.sort((elemA, elemB) =>
          elemA.label.localeCompare(elemB.label)
        );
        this.setState({
          filteredFxPairs: fxPairs
        });
      } else if (controls.dataType === DATA_TYPES.OTC_WITHDRAWAL) {
        this.loadOtcBalances(controls.merchant);
      }
    } else if (field === "psp") {
      controls.midIds = [];
      controls.midIds = midIdsField && midIdsField.type === "isArray" ? [] : "";
      controls.accountIds = [];
      if (controls.dataType === DATA_TYPES.OTC_CASHOUT || controls.dataType === DATA_TYPES.OTC_CASHOUT_UPDATE || controls.dataType === DATA_TYPES.PAYOUT_TOP_UP) {
        controls.fxPair = "";
        controls.currency = "";
        const otcCashoutCurrencies = this.getFilteredCurrencies(companiesAccounts[controls.company], companiesBaseCurrencies[controls.company], controls.psp);
        if (isSingleElementArray(otcCashoutCurrencies)) {
          this.onValueChange(otcCashoutCurrencies[0], "currency");
        };
        this.setState({
          otcCashoutCurrencies
        });
      }
      if (controls.dataType === DATA_TYPES.OTC_SETTLEMENT) {
        controls.midIds = this.filterMidsByPSPAndCurrency(controls).map(elem => elem.value);
      }
    } else if (field === "currency") {
      if (isAutoRequest) {
        const newMids = this.getMidsOptions();
        controls.midIds = newMids?.map(mid => mid.value);
      } else {
        controls.midIds = midIdsField && midIdsField.type === "isArray" ? [] : "";
      }
      if (controls.dataType === DATA_TYPES.OTC_CASHOUT_UPDATE) {
        controls.accountIds = this.filterAccountsByCurrencyAndSelect(companiesAccounts[controls.company], controls[field], controls.psp).map(account => account.value);
        this.loadInvoicesData(controls.currency, controls.company, controls.accountIds);
      } else if ((controls.dataType === DATA_TYPES.PAYOUT_TOP_UP || controls.dataType === DATA_TYPES.OTC_CASHOUT) && controls.psp) {
        const fxPairs = this.getFilteredFxPairs(controls, companiesFxPairs, companiesAccounts);
        if (isSingleElementArray(fxPairs)) {
          this.onValueChange(fxPairs[0], "fxPair");
        } else {
          controls.accountIds = [];
        }
      } else if (controls.dataType === DATA_TYPES.OTC_SETTLEMENT) {
        controls.fxPair = "";
        const merchantFxPairs = companiesClients[controls.company].find(client => client.value === controls.merchant).fxPairs || [];
        const fxPairs = merchantFxPairs.filter(elem =>  elem.split("/")[1] === controls.currency).map((pair) => {
          return { value: pair, label: this.getFxPairValue(pair)};
        });
        fxPairs.sort((elemA, elemB) =>
          elemA.label.localeCompare(elemB.label)
        );
        this.setState({
          filteredFxPairs: fxPairs
        });
      }
    } else if (field === "fxPair") {
      controls.accountIds = this.filterAccountsByFxPairAndSelect(companiesAccounts[controls.company], controls[field], controls["psp"]).map(account => account.value);
      if (controls.dataType === DATA_TYPES.OTC_SETTLEMENT) {
        controls.psp = companiesPsps[controls.company].map(psp => psp.value);
        controls.midIds = this.filterMidsByPSPAndCurrency(controls).map(elem => elem.value);
      }
    } else if (field === "date" && controls.dataType === DATA_TYPES.OTC_CASHOUT_UPDATE) {
      controls.invoice = controls.date && controls.currency && otcCashoutInvoiceFullInfo[controls.date]
        ? otcCashoutInvoiceFullInfo[controls.date].map(elem => elem.invoice)
        : [];
    } else if (field === "dataType") {
      this.setState({
        submitClicked: false,
        showSecondPanel: false,
        showThirdPanel: false,
      });
      if (event?.value === DATA_TYPES.TOP_UP_PAYOUT_WALLET || event?.value === DATA_TYPES.OTC_CASHOUT || event?.value === DATA_TYPES.PAYOUT_TOP_UP) {
        controls.date = Datetime.moment();
        this.setState({
          date: Datetime.moment()
        });
      }
    } else if (field === "accountIds" && controls.dataType === DATA_TYPES.OTC_CASHOUT_UPDATE) {
      this.loadInvoicesData(controls.currency, controls.company, controls.accountIds);
    }

    if (field !== "updateSettlementDate" && field !== "settlementId") {
      this.loadLastDate(isAutoRequest);
    }

    if (field === "updateSettlementDate" && (controls.dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST
      || controls.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST)) {
      this.loadSettlementsByDate();
    }

    if (submitClicked) {
      controls.isFormValid();
    }

    this.setState({
      controls: field === "dataType" || field === "otcCashoutStatus" ? this.defineControlsForm(controls.dataType) : controls
    }, () => {
      if (isAutoRequest && (controls.dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET || controls.dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST || controls.dataType === DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST)) {
        this.callOnChangeFilter();
      }
    });
  };

  loadOtcBalances = (clientId) => {
    crudActions.get(`v1/otc/balances/${ clientId }`)
      .then((response) => {
        const otcCurrencies = response?.map(elem => ({
          value: elem.currency,
          label: elem.currency
        })).sort((elemA, elemB) => elemA.label.localeCompare(elemB.label));
        const otcBalances = response?.reduce((obj, { currency, balance }) => {
          obj[currency] = balance;
          return obj;
        }, {});
        this.setState({
          otcCashoutCurrencies: otcCurrencies,
          otcBalances: otcBalances
        }, () => {
          if (isSingleElementArray(otcCurrencies)) {
            this.onValueChange(otcCurrencies[0], "currency");
          }
        });
      })
      .catch(err => {
        if (err && err.message) {
          this.props.showAlert(true, "error", err.message);
        }
      });
  };

  loadOtcWallets = () => {
    const { controls } = this.state;
    crudActions.get(`v1/otc/balances/wallets?clientId=${ controls.merchant }&currency=${ controls.currency }`)
      .then((response) => {
        const otcWallets = response.map(wallet => ({
          value: String(wallet.id),
          label: wallet.walletName
        })).sort((elemA, elemB) => elemA.label.localeCompare(elemB.label));
        this.setState({
          otcWallets
        });
      })
      .catch(err => {
        if (err && err.message) {
          this.props.showAlert(true, "error", err.message);
        }
      });
  };

  getFilteredFxPairs = (controls, companiesFxPairs, companiesAccounts) => {
    const fxPairs =  this.filterAndMapFxPairs(companiesFxPairs[controls.company], controls.psp, companiesAccounts[controls.company], controls.currency);
    fxPairs.push(this.getBasePair(controls.currency));
    fxPairs.sort((elemA, elemB) =>
      elemA.label.localeCompare(elemB.label)
    );
    this.setState({
      filteredFxPairs: fxPairs
    });
    return fxPairs;
  };

  autoPopulateSettlement = (data) => {
    const {
      companiesBaseCurrencies,
      companiesClients,
      companiesPsps,
      controls,
      dataTypes,
      mids,
      otcSettlementsActionType
    } = this.state;

    const typesToSearch = data.otc ? otcSettlementsActionType : dataTypes;

    const newDataType = typesToSearch.find(type => type.value === data.dataType);
    const newMerchant = companiesClients[controls.company].find(client => client.value === data.merchantId.toString());
    const newCurrency = companiesBaseCurrencies[controls.company].find(currency => currency.value === data.currency);

    const validDataTypesForMultiMerchant = [
      DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST,
      DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST
    ];

    this.onValueChange(newDataType, "dataType");
    this.onValueChange(validDataTypesForMultiMerchant.includes(data.dataType) ? [newMerchant] : newMerchant, "merchant");
    this.onValueChange(newCurrency, "currency", data.dataType !== DATA_TYPES.TOP_UP_PAYOUT_WALLET);

    if (data.dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET) {
      const newMidId = mids.find(mid => mid.value === data.mid);
      const newProviderId = companiesPsps[controls.company].find(mid => mid.value === data.providerId.toString());
      this.onValueChange(newProviderId, "psp");
      this.onValueChange(newMidId, "midIds", true);
    }
    if (validDataTypesForMultiMerchant.includes(data.dataType)) {
      const id = data.dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST ? Number(data.id) : data.id;
      this.onValueChange({ value: id, label: id }, "id", true);
    }
  };

  loadSettlementFeeData = (clientId) => {
    crudActions.get(`v1/default-commercials/fees/${clientId}`)
      .then((response) => {
        const otcCurrencies = response.map(elem => ({ value: elem.currency, label: elem.currency })).sort((elemA, elemB) => elemA.label.localeCompare(elemB.label));
        this.setState({
          otcCashoutCurrencies: otcCurrencies,
          settlementFeeData: response
        }, () => {
          if (isSingleElementArray(otcCurrencies)) {
            this.onValueChange(otcCurrencies[0], "currency");
          }
        });
      })
      .catch(err => {
        if (err && err.message) {
          this.props.showAlert(true, "error", err.message);
        }
      });
  };

  getBasePair = (currency) => {
    return { value: currency + "/" + currency, label: currency };
  };

  getFilteredCurrencies = (accounts, currencies, pspIds) => {
    const accountsCurrencies = accounts.filter((elem) => pspIds.includes(elem.pspId.toString())).map(acc => acc.currency);
    return currencies.filter(currency => accountsCurrencies.includes(currency.value)).sort((elemA, elemB) =>
      elemA.label.localeCompare(elemB.label)
    );
  };

  loadInvoicesData = (currency, company, accountIds) => {
    const { controls } = this.state;
    const requestData = {
      currency,
      companyId: company,
      accountIds
    };
    crudActions.post(`v1/incoming/funds/dates`, requestData)
      .then((dates) => {
        if (dates) {
          dates.sort((a, b) => dateToNumber(b) - dateToNumber(a));
          controls.date = dates[0] || "";

          this.setState({
            controls: controls,
            otcCashoutInvoiceDates: dates.map(elem => ({ value: elem, label: elem }))
          });
        }
      })
      .catch((err) => {
        this.props.showAlert(true, "error", err?.message);
      });
  };

  loadLastDate = (isAutoRequest) => {
    const { controls } = this.state;

    const dateNow = Datetime.moment();

    if (
      controls.midIds &&
      controls.midIds.length &&
      controls.merchant &&
      controls.dataType === DATA_TYPES.SETTLEMENT_BY_DATE
    ) {
      crudActions
        .get(
          `v1/data/input/settlements?midId=${controls.midIds}&clientId=${controls.merchant}`
        )
        .then((response) => {
          if (response) {
            const lastSettlementDate = response.data
              ? Datetime.moment(response.data, "DD.MM.YYYY")
              : "";

            this.setState({
              lastSettlementDate
            });
          }
        })
        .catch((err) => {
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
          }

          this.setState({
            lastSettlementDate: ""
          });
        });
    }

    if (
      controls.dataType === DATA_TYPES.UPDATE_SETTLEMENT &&
      controls.midIds &&
      controls.merchant &&
      controls.settlementStatus
    ) {
      crudActions
        .get(
          `v1/data/input/dropdown-dates?midIds=${controls.midIds}&clientId=${controls.merchant}&propertyId=${controls.settlementStatus}`
        )
        .then((dates) => {
          if (dates) {
            this.setState({
              settlementDates: dates,
              controls: Object.assign(controls, {
                updateSettlementDate: dates.length ? dates[0].value : "",
              }),
            });
          }
        })
        .catch((err) => {
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
          }
        });
    }

    if (
      (controls.dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST || controls.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) &&
      controls.midIds &&
      controls.midIds.length &&
      controls.merchant &&
      controls.currency
    ) {
      const url = controls.dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST ? "v1/data/input/dropdown-dates/requested" : "v1/otc/settlement/dropdown-dates/requested";
      crudActions
        .get(
          `${url}?clientId=${controls.merchant}&currency=${controls.currency}`
        )
        .then((dates) => {
          if (dates) {
            let newDate = dates.length ? dates[0].value : "";
            if (isAutoRequest) {
              newDate = this.props.location?.state?.requestDate;
            }
            this.setState({
              settlementDates: dates,
              controls: Object.assign(this.state.controls, {
                updateSettlementDate: newDate,
              }),
            }, () => {
              if (newDate) {
                this.loadSettlementsByDate(isAutoRequest);
              }
            });
          }
        })
        .catch((err) => {
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
          }
        });
    }

    this.setState({
      dateNow
    });
  };

  loadSettlementsByDate = (isAutoRequest) => {
    const { controls } = this.state;
    const isOtc = controls.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST;
    const url = `v1/data/input/dropdown-times/requested?clientId=${ controls.merchant }&date=${ controls.updateSettlementDate }&currency=${ controls.currency }&isOtc=${ isOtc }`;
    crudActions.get(url)
      .then((response) => {
        if (response) {
          let firstSettlement = response.length ? response[0].value : "";
          if (isAutoRequest) {
            const settlementId = this.props.location?.state?.id;
            firstSettlement = response?.find(item => Number(item.value) === settlementId)?.value;
          }
          this.setState({
            settlementsForDate: response,
            controls: Object.assign(this.state.controls, {
              settlementId: firstSettlement,
            }),
          }, () => {
            if (isAutoRequest) {
              this.callOnChangeFilter();
            }
          });
        }
      })
      .catch((err) => {
        if (err && err.message) {
          this.props.showAlert(true, "error", err.message);
        }
      });
  };

  isPrecise = (num, count = 2) => {
    return String(num).split(".")[1]?.length <= count;
  };

  onCreditDebitChange = (event, field, id) => {
    const { debitCreditForm, savedData } = this.state;
    const debitCreditFormSingle = debitCreditForm[id];

    const dynamicKey = `midsForCredit${id + 1}`;
    if (field === "debitMidId") {
      this.getMidBalance(savedData.merchant, event.value, savedData.psp, savedData.company).then(balance => {
        debitCreditFormSingle.debitBalance = balance;
        debitCreditFormSingle.creditAmount = "";
        debitCreditFormSingle[field] = event.value;
        debitCreditFormSingle.disabled = !balance;
        if (debitCreditFormSingle.creditPsp) {
          this.setState({
            [dynamicKey]: this.filterMids(debitCreditFormSingle.creditPsp, null, null, savedData.currency).filter(mid => mid.value !== debitCreditFormSingle.debitMidId),
          });
        }
        this.setState({ debitCreditForm });
      });
    } else if (field === "creditPsp") {
      debitCreditFormSingle.creditMidId = "";
      debitCreditFormSingle.creditBalance = "";
      debitCreditFormSingle[field] = event.value;
      this.setState({
        [dynamicKey]: this.filterMids(event.value, null, null, savedData.currency).filter(mid => mid.value !== debitCreditFormSingle.debitMidId),
      });
    } else if (field === "creditMidId") {
      this.getMidBalance(savedData.merchant, event.value, savedData.psp, savedData.company).then(balance => {
        debitCreditFormSingle.creditBalance = balance;
        this.setState({ debitCreditForm });
      });
      debitCreditFormSingle[field] = event.value;
    } else if (field === "creditAmount") {

      let value = event.target.value;

      value = value.replace(/[^0-9.]/g, "");
      if (value.split('.').length > 2) {
        value = value.slice(0, value.lastIndexOf('.'));
      }
      if (parseFloat(value) <= (debitCreditFormSingle.debitBalance - this.getLockDebit(debitCreditFormSingle.debitMidId, id)) && parseFloat(value) > 0) {
        debitCreditFormSingle[field] = value;
      }
      if ( value === "") {
        debitCreditFormSingle[field] = value;
      }
      debitCreditFormSingle.isChecked = debitCreditFormSingle.debitBalance === debitCreditFormSingle.creditAmount;
    }
    this.setState({ debitCreditForm });
  };

  getLockDebit = (midId, index) => {
    const { debitCreditForm } = this.state;
    return debitCreditForm
      .filter((elem, idx) => elem.debitMidId === midId && idx !== index)
      .reduce((sum, elem) => sum + (elem.creditAmount || 0), 0);
  };

  getMidBalance = async (clientId, midId, providerId, companyId) => {
    const requestData = {
      clientId: clientId,
      midId: midId,
      providerId: providerId,
      companyId: companyId
    };

    try {
      const response = await crudActions.post(`v1/mids/balances`, requestData);
      const midInfo = response.find(info => info.midId === midId);

      if (midInfo) {
        return midInfo.balance;
      } else {
        return 0;
      }
    } catch (err) {
      if (err && err.message) {
        this.props.showAlert(true, "error", err.message);
      }
      return 0;
    }
  };

  onSettlementChange = (event, field, id) => {
    const { dataType } = this.state.savedData;
    id = this.state.showThirdPanel ? id + this.state.firstPanelLength : id;
    const settlementFormName = this.formsMap[dataType];
    let settlementForm = this.state[settlementFormName];
    const settlementFormOriginal = settlementForm;
    const prevValue = settlementForm[field];

    const validFormsForOriginal = [
      this.formsMap.OTC_CASHOUT,
      this.formsMap.OTC_CASHOUT_UPDATE,
      this.formsMap.PAYOUT_TOP_UP,
      this.formsMap.TOP_UP_PAYOUT_WALLET_BY_REQUEST,
      this.formsMap.SETTLEMENT_BY_AMOUNT,
      this.formsMap.SETTLEMENT_BY_DATE,
      this.formsMap.SETTLEMENT_BY_REQUEST,
      this.formsMap.UPDATE_SETTLEMENT,
      this.formsMap.OTC_SETTLEMENT_BY_REQUEST,
      this.formsMap.OTC_SETTLEMENT,
      this.formsMap.OTC_WITHDRAWAL,
      this.formsMap.OTC_WITHDRAWAL_BY_REQUEST
    ];
    settlementForm = validFormsForOriginal.includes(settlementFormName) ? settlementFormOriginal[id] : settlementForm;

    const validFormsForBalanceToSettle = [
      this.formsMap.SETTLEMENT_BY_AMOUNT,
      this.formsMap.SETTLEMENT_BY_DATE,
      this.formsMap.SETTLEMENT_BY_REQUEST,
      this.formsMap.OTC_SETTLEMENT
    ];
    if (validFormsForBalanceToSettle.includes(settlementFormName) && field === "balanceToSettle") {
      this.onMidRowChange(event, field, id);
      return;
    }

    const { controls, saveClicked, savedData, savedDataList, settlementMids } = this.state;

    const validDataTypesForNotes = [
      DATA_TYPES.OTC_CASHOUT,
      DATA_TYPES.PAYOUT_TOP_UP,
      DATA_TYPES.SETTLE_AGENT,
      DATA_TYPES.SETTLEMENT_BY_AMOUNT,
      DATA_TYPES.SETTLEMENT_BY_DATE,
      DATA_TYPES.SETTLEMENT_BY_REQUEST,
      DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST,
      DATA_TYPES.OTC_SETTLEMENT,
      DATA_TYPES.OTC_WITHDRAWAL
    ];

    const validDataTypesForRequestedSettlement = [
      DATA_TYPES.SETTLEMENT_BY_AMOUNT,
      DATA_TYPES.SETTLEMENT_BY_DATE,
      DATA_TYPES.SETTLEMENT_BY_REQUEST,
      DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST,
      DATA_TYPES.OTC_SETTLEMENT
    ];

    const validDataTypesForConfirmationLink = [
      DATA_TYPES.OTC_CASHOUT,
      DATA_TYPES.OTC_SETTLEMENT,
      DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST,
      DATA_TYPES.PAYOUT_TOP_UP,
      DATA_TYPES.OTC_WITHDRAWAL,
      DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST
    ];

    if ((validDataTypesForNotes.includes(controls.dataType) && field === "notes") || (validDataTypesForConfirmationLink.includes(controls.dataType) && field === "confirmationLink")) {
      settlementForm[field] = event.target.value;
    } else {
      const isNumber = settlementForm.fieldRules.find((rule) => rule.name === field).type === "isNumber";
      const numberRegex = new RegExp(/^\d+$/);
      if (!event) {
        const matchNumber = event.match(numberRegex);
        settlementForm[field] = isNumber
          ? parseInt(matchNumber ? matchNumber[0] : settlementForm[field])
          : event;
      } else if (event.target) {
        const regex = controls.dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET || controls.dataType === DATA_TYPES.PAYOUT_TOP_UP || controls.dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST ? /[^0-9\-.]/g : /[^0-9.]/g;
        const value = event.target.value ? event.target.value.replace(regex, "") : "";
        const isTopUpField = field === "topUpAmount" && (
          controls.dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET ||
          controls.dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST
        );
            
        if ((validDataTypesForRequestedSettlement.includes(controls.dataType) && field === "requestedSettlement") ||
          isTopUpField || (controls.dataType === DATA_TYPES.OTC_WITHDRAWAL && field === "balanceToSettle") ||
          ((controls.dataType === DATA_TYPES.OTC_CASHOUT || controls.dataType === DATA_TYPES.PAYOUT_TOP_UP) && (field === "requestedBalance" || field === "fxRate" || field === "incomingFunds"))
        ) {
          const newValueIsLowerThanAB = parseFloat(settlementForm.availableBalance) >= 0 ? (parseFloat(value) <= parseFloat(settlementForm.availableBalance)) : parseFloat(value) < 0;
          const otcCashoutABEnough = this.isOtcCashoutABEnough(settlementForm, field, controls.dataType, parseFloat(value));
          if ((newValueIsLowerThanAB && otcCashoutABEnough) || value === "-" || value === "") {
            if (value.indexOf(".") > -1 && field !== "fxRate" && field !== "incomingFunds") {
              if (this.isPrecise(value)) {
                settlementForm[field] = value;
              }
            } else {
              settlementForm[field] = value;
            }
            if (isTopUpField) {
              this.recalculateTopUpFee(settlementForm);
            }
            const fieldNameToUpdate = "disabled";
            if (controls.dataType === DATA_TYPES.OTC_CASHOUT) {
              const fxPairArray = controls.fxPair.split("/");
              const isFxRateFixed = fxPairArray[0] === fxPairArray[1];
              if (isFxRateFixed) {
                if (settlementForm[field]) {
                  this.reCalculateIncomingFunds(settlementFormOriginal);
                } else {
                  settlementForm.incomingFunds = "";
                }
                this.reCalculateAllIncomingFunds(settlementFormOriginal);
                this.reCalculateAllRequestedBalance(settlementFormOriginal);
                settlementForm.isChecked = parseFloat(settlementForm.availableBalance) === parseFloat(settlementForm.requestedBalance);
              } else {
                if (field === "requestedBalance") {
                  const incomingFundsDisabled = this.getFiledRule(this.fieldsMap[controls.dataType][id], "incomingFunds", fieldNameToUpdate);
                  if (settlementForm[field]) {
                    if (!settlementForm.incomingFunds || !settlementForm.fxRate) {
                      if (settlementForm.incomingFunds && !incomingFundsDisabled) {
                        this.fieldsMap[controls.dataType][id] = this.updateFiledRule(this.fieldsMap[controls.dataType][id], "fxRate",
                          fieldNameToUpdate, true);
                      } else if (settlementForm.fxRate) {
                        this.fieldsMap[controls.dataType][id] = this.updateFiledRule(this.fieldsMap[controls.dataType][id], "incomingFunds",
                          fieldNameToUpdate, true);
                      }
                    }
                    if (incomingFundsDisabled || (settlementForm.fxRate && !settlementForm.incomingFunds)) {
                      this.reCalculateIncomingFunds(settlementFormOriginal);
                    } else {
                      this.reCalculateFxRate(settlementFormOriginal, id);
                    }
                  } else if (!settlementForm[field]) {
                    if (incomingFundsDisabled && settlementForm.incomingFunds && settlementForm.fxRate) {
                      settlementForm.incomingFunds = "";
                      this.fieldsMap[controls.dataType][id] = this.updateFiledRule(this.fieldsMap[controls.dataType][id], "incomingFunds",
                        fieldNameToUpdate, false);
                    } else {
                      settlementForm.fxRate = "";
                      this.fieldsMap[controls.dataType][id] = this.updateFiledRule(this.fieldsMap[controls.dataType][id], "fxRate",
                        fieldNameToUpdate, false);
                    }
                  }
                } else if (field === "incomingFunds") {
                  const requestedBalanceDisabled = this.getFiledRule(this.fieldsMap.OTC_CASHOUT[id], "requestedBalance", fieldNameToUpdate);
                  if (settlementForm[field]) {
                    if (!settlementForm.requestedBalance || !settlementForm.fxRate) {
                      if (settlementForm.requestedBalance && !requestedBalanceDisabled) {
                        this.fieldsMap.OTC_CASHOUT[id] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[id], "fxRate",
                          fieldNameToUpdate, true);
                      } else if (settlementForm.fxRate) {
                        this.fieldsMap.OTC_CASHOUT[id] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[id], "requestedBalance",
                          fieldNameToUpdate, true);
                      }
                    }
                    if (requestedBalanceDisabled || (settlementForm.fxRate && !settlementForm.requestedBalance)) {
                      this.reCalculateRequestedBalance(settlementFormOriginal);
                    } else {
                      this.reCalculateFxRate(settlementFormOriginal, id);
                    }
                    this.reCalculateAllIncomingFunds(settlementFormOriginal);
                  } else if (!settlementForm[field]) {
                    if (requestedBalanceDisabled && settlementForm.requestedBalance && settlementForm.fxRate) {
                      settlementForm.requestedBalance = "";
                      this.fieldsMap.OTC_CASHOUT[id] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[id], "requestedBalance",
                        fieldNameToUpdate, false);
                    } else {
                      settlementForm.fxRate = "";
                      this.fieldsMap.OTC_CASHOUT[id] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[id], "fxRate",
                        fieldNameToUpdate, false);
                    }
                  }

                } else if (field === "fxRate") {
                  const requestedBalanceDisabled = this.getFiledRule(this.fieldsMap.OTC_CASHOUT[id], "requestedBalance", fieldNameToUpdate);
                  if (settlementForm[field]) {
                    if (!settlementForm.requestedBalance || !settlementForm.incomingFunds) {
                      if (settlementForm.requestedBalance && !requestedBalanceDisabled) {
                        this.fieldsMap.OTC_CASHOUT[id] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[id], "incomingFunds",
                          fieldNameToUpdate, true);
                      } else if (settlementForm.incomingFunds) {
                        this.fieldsMap.OTC_CASHOUT[id] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[id], "requestedBalance",
                          fieldNameToUpdate, true);
                      }
                    }
                    if (requestedBalanceDisabled || (settlementForm.incomingFunds && !settlementForm.requestedBalance)) {
                      this.reCalculateRequestedBalance(settlementFormOriginal);
                    } else {
                      this.reCalculateIncomingFunds(settlementFormOriginal);
                    }
                  } else if (!settlementForm[field]) {
                    if (requestedBalanceDisabled && settlementForm.requestedBalance && settlementForm.incomingFunds) {
                      settlementForm.requestedBalance = "";
                      this.fieldsMap.OTC_CASHOUT[id] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[id], "requestedBalance",
                        fieldNameToUpdate, false);
                    } else {
                      settlementForm.incomingFunds = "";
                      this.fieldsMap.OTC_CASHOUT[id] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[id], "incomingFunds",
                        fieldNameToUpdate, false);
                    }
                  }
                }
                settlementForm.isChecked = parseFloat(settlementForm.availableBalance) === parseFloat(settlementForm.requestedBalance);
                this.reCalculateAllRequestedBalance(settlementFormOriginal);
                this.reCalculateAllIncomingFunds(settlementFormOriginal);
              }
            } else if (controls.dataType === DATA_TYPES.OTC_WITHDRAWAL) {
              settlementForm.isChecked = parseFloat(settlementForm.availableBalance) === parseFloat(settlementForm.balanceToSettle);
            }
          }
        } else {
          let newValue = value;
          if (field === "balanceToSettle" && controls.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) {
            if (parseFloat(newValue) > parseFloat(this.state[settlementFormName + 'Total'].requestedSettlement)) {
              newValue = String(prevValue);
            }
          }
          if (newValue.indexOf(".") > -1 && (controls.dataType === DATA_TYPES.OTC_SETTLEMENT || controls.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST)) {
            let count = 2;
            if (controls.dataType === DATA_TYPES.OTC_SETTLEMENT && field === "fxRate") {
              count = 4;
            }
            if (this.isPrecise(newValue, count) && newValue.split(".").length <= 2) {
              if (newValue.indexOf(".") === newValue.length - 1 || newValue[newValue.length - 1] === "0" || field === "fxRate") {
                settlementForm[field] = newValue;
              } else {
                settlementForm[field] = parseFloat(newValue);
              }
            }
          } else {
            settlementForm[field] = (newValue && field !== "fxRate") ? parseFloat(newValue) : newValue;
          }
        }
      } else if (event.value) {
        const matchNumber = event.value.match(numberRegex);
        settlementForm[field] = isNumber
          ? parseInt(matchNumber ? matchNumber[0] : settlementForm[field])
          : event.value;
      } else {
        settlementForm[field] = event.map((elem) => elem.value);
      }

      if ([DATA_TYPES.SETTLEMENT_BY_AMOUNT, DATA_TYPES.OTC_SETTLEMENT].includes(controls.dataType) && field === "balanceToSettle") {
        const balanceToSettleField = settlementForm.fieldRules.find(
          (fieldRule) => fieldRule.name === field
        );
        balanceToSettleField.rules.max = savedData.runningBalanceAmount;
      }

      if (DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST === controls.dataType) {
        if (field === "midId") {
          this.getMidBalance(settlementForm.merchant, settlementForm.midId, settlementForm.providerId, savedData.company).then(balance => {
            settlementForm.availableBalance = balance;
            this.setState({
              [settlementFormName]: settlementFormOriginal,
            });
            if (saveClicked) {
              settlementForm.isFormValid();
            }
          });
        }
        if (field === "providerId") {
          settlementForm.availableBalance = 0;
          settlementForm.midId = "";
        }
      }

      if (validDataTypesForRequestedSettlement.includes(controls.dataType) && field === "requestedSettlement") {
        settlementForm.balanceToSettle = 0;
        for (let i = 0; i < settlementMids.length; i++) {
          settlementMids[i].balanceToSettle = 0;
          settlementMids[i].isChecked = false;
        }
      }

      if (field === "balanceToSettle" && controls.dataType !== DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) {
        settlementForm[field] = settlementForm[field] ? parseInt(settlementForm[field], 10) : "";
      }

      if (field === "balanceToSettle" && controls.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) {
        const otcKey = `${settlementFormName}Otc`;
        const otcForm = this.state[otcKey];
        const exchanged = settlementForm.balanceToSettle / otcForm.fxRate;
        otcForm.settlementFee = exchanged * (otcForm.settlementFeeValue / 100);
        otcForm.otcSettlement = exchanged - otcForm.settlementFee;
        this.setState({
          [otcKey]: otcForm
        });
      }

      if (field === "propertyId" && dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) {
        const otcForm = this.state[this.formsMap[dataType] + "Otc"];
        const confirmationLinkField =  otcForm.fieldRules.find(
          (fieldRule) => fieldRule.name === "confirmationLink"
        );
        confirmationLinkField.rules.required = controls.settlementStatus === 19;
        const settlementFeeField = otcForm.fieldRules.find(
          (fieldRule) => fieldRule.name === "settlementFee"
        );
        settlementFeeField.rules.required = controls.settlementStatus === 19;
      }
      if (field === "fxPair") {
        settlementFormOriginal.forEach(item => {
          if (item.hasOwnProperty(field)) {
            item[field] = event.value;
          }
        });
        if (controls.dataType === DATA_TYPES.OTC_SETTLEMENT) {
          settlementFormOriginal[settlementFormOriginal.length - 1].currency = event.value.split("/")[0];
        }
      } else if (field === "fxRate" && controls.dataType === DATA_TYPES.OTC_SETTLEMENT) {
        const totalRow = settlementFormOriginal[settlementFormOriginal.length - 1];
        totalRow.otcCalculated = this.reCalculateOtcCalculated(settlementFormOriginal);
        totalRow.settlementFee = totalRow.otcCalculated * (totalRow.settlementFeeValue / 100);
        totalRow.otcSettlement = totalRow.otcCalculated - totalRow.settlementFee;
      }
    }
    if (saveClicked) {
      settlementForm.isFormValid();
    }

    this.setState({
      [settlementFormName]: settlementFormOriginal,
      savedDataList: savedDataList,
      settlementMids
    });
  };

  isOtcCashoutABEnough = (settlementForm, field, dataType, value) => {
    if (dataType === DATA_TYPES.OTC_CASHOUT_UPDATE) {
      return true;
    }
    if (settlementForm.requestedBalance) {
      return true;
    }
    if (field === "fxRate" && settlementForm.incomingFunds) {
      return (parseFloat(settlementForm.incomingFunds) * value) <= parseFloat(settlementForm.availableBalance);
    } else if (field === "incomingFunds" && settlementForm.fxRate) {
      return (parseFloat(settlementForm.fxRate) * value) <= parseFloat(settlementForm.availableBalance);
    } else {
      return true;
    }
  };

  reCalculateOtcCalculated = (form) => {
    return form
      .slice(this.state.firstPanelLength, -1)
      .reduce((sum, elem) => {
        const amount = parseFloat(elem.amount);
        const fxRate = parseFloat(elem.fxRate);

        if (!isNaN(amount) && !isNaN(fxRate) && fxRate !== 0) {
          return sum + amount / fxRate;
        }

        return sum;
      }, 0);
  };

  updateFiledRule = (fields, fieldName, fieldNameToUpdate, newValue) => {
    return fields.map(elem => elem.name === fieldName ? { ...elem, [fieldNameToUpdate]: newValue } : elem);
  };

  getFiledRule = (fields, fieldName, fieldNameRule) => {
    return fields.find(elem => elem.name === fieldName)[fieldNameRule];
  };

  reCalculateFxRate = (cashoutForm, index) => {
    cashoutForm.forEach((item, i) => {
      if (i === index && item["requestedBalance"] && item["incomingFunds"] && parseFloat(item["incomingFunds"]) !== 0 && item.account !== "All") {
        item["fxRate"] = (item["requestedBalance"] / item["incomingFunds"]).toFixed(2);
      }
    });
  };

  reCalculateIncomingFunds = (cashoutForm) => {
    cashoutForm.forEach((item)=> {
      if (item["requestedBalance"] && item["fxRate"] && parseFloat(item["fxRate"]) !== 0 && item.account !== "All") {
        item["incomingFunds"] = parseFloat(item["requestedBalance"] / item["fxRate"]).toFixed(2);
      }
    });
  };

  reCalculateRequestedBalance = (cashoutForm) => {
    cashoutForm.forEach((item)=> {
      if (item["incomingFunds"] && item["fxRate"] && item.account !== "All") {
        item["requestedBalance"] = parseFloat(item["incomingFunds"] * item["fxRate"]).toFixed(2);
      } else if (!item["incomingFunds"] && !item["fxRate"] && item.account !== "All") {
        item["requestedBalance"] = "";
      }
    });
  };

  reCalculateAllIncomingFunds = (cashoutForm) => {
    cashoutForm.forEach(elem => {
      if (elem.account === "All") {
        elem["incomingFunds"] = cashoutForm.filter(item => item.account !== "All")
          .reduce((sum, item) => sum + (parseFloat(item.incomingFunds) || 0), 0).toFixed(2);
      }
    });
  };

  reCalculateAllRequestedBalance = (cashoutForm) => {
    const allRow = cashoutForm.find( elem => elem.hasOwnProperty("account") && elem["account"] === "All");
    if (allRow) {
      allRow["requestedBalance"] = cashoutForm.filter(elem => elem.requestedBalance && elem.account !== "All").reduce((acc, item) => acc + parseFloat(item.requestedBalance), 0).toFixed(2);
    }
  };

  recalculateTopUpFee = (form) => {
    const topUpAmount = form["topUpAmount"];
    const payoutFee = form["payoutFee"];
    if (!parseFloat(topUpAmount)|| !payoutFee || parseFloat(topUpAmount) <= 0) {
      form["topUpFee"] = 0;
      return;
    }
    form["topUpFee"] = parseFloat(topUpAmount * (payoutFee / 100)).toFixed(2);
  };

  onMidRowChange = (event, field, index) => {
    const { savedData } = this.state;
    const settlementFormName = this.formsMap[savedData.dataType];
    const settlementForm = this.state[settlementFormName + "Total"];
    let settlementMids = this.state[settlementFormName + "Mids"];

    if (field === "balanceToSettle") {
      const value = event.target.value.replace(/[^0-9.]/g, "");
      const withinBalance = value <= settlementMids[index].availableBalance;
      const withinCollectedFunds = savedData.dataType === DATA_TYPES.OTC_SETTLEMENT
        ? this.isCollectedFundsEnough(value, index, settlementMids) : true;

      if (withinBalance && withinCollectedFunds) {
        if (value !== "") {
          if (value.indexOf(".") > -1) {
            if (this.isPrecise(value)) {
              settlementMids[index][field] = value;
            }
          }
          const parsedValue = parseFloat(value);
          if (typeof value === "string" && value.indexOf(".") !== value.length - 1) {
            settlementMids[index][field] = parsedValue;
          }
          settlementMids[index].isChecked = parsedValue === settlementMids[index].availableBalance ||
            (withinCollectedFunds && parsedValue === this.availableCollectedFunds(settlementMids, index));
          if (withinCollectedFunds && (this.availableCollectedFunds(settlementMids, index) === parsedValue)) {
            settlementMids =  this.disableOtherZeroBalanceMids(settlementMids, index, savedData.dataType, true);
          }
          let sumToSettle = 0;
          for (let i = 0; i < settlementMids.length; i++) {
            if (settlementMids[i].balanceToSettle) {
              sumToSettle += parseFloat(parseFloat(settlementMids[i].balanceToSettle).toFixed(2));
            }
          }
          settlementForm.balanceToSettle = parseFloat(sumToSettle.toFixed(2));
        } else {
          settlementMids[index][field] = "";
          settlementMids[index].isChecked = false;
          let sumToSettle = 0;
          for (let i = 0; i < settlementMids.length; i++) {
            if (settlementMids[i].balanceToSettle) {
              sumToSettle += parseFloat(parseFloat(settlementMids[i].balanceToSettle).toFixed(2));
            }
          }
          settlementForm.balanceToSettle = parseFloat(sumToSettle.toFixed(2));
        }

      }
      settlementForm.requestedSettlement = "";
      const midsZeroSettle = settlementMids.filter(f => f.balanceToSettle > 0);
      this.changeRequestedSettlementFieldStatus(savedData.dataType, midsZeroSettle.length > 0);
    }
    this.setState({
      settlementMids
    });
  };

  isCollectedFundsEnough = (value, index, settlementMids) => {
    if (!value) return true;
    const pspAccountId = settlementMids[index].pspAccountId;
    const balanceToSettleByAcc = parseInt(value) + settlementMids.filter((s, i) => {
      if (index === i) {
        return false;
      } else {
        return s.pspAccountId === pspAccountId;
      }
    }
    ).reduce((acc, item) => acc + (item.balanceToSettle ? parseInt(item.balanceToSettle) : 0), 0);
    return balanceToSettleByAcc <= settlementMids[index].collectedFunds;
  };

  onChangeFilter = () => {
    const { controls, date, companiesBaseCurrencies, mids } = this.state;
    const isFormValid = controls.isFormValid();

    this.updateStateAfterOnChangeValidation(controls, isFormValid);

    const formattedDate = Datetime.moment(date).format("DD.MM.YYYY");

    if (isFormValid) {
      const { merchant, dataType, midIds } = controls;

      let url = `v1/data/input?clientId=${ merchant }&dataInputTypes=${ dataType }&midIds=${ midIds }`;
      if (dataType === DATA_TYPES.RUNNING_BALANCE || dataType === DATA_TYPES.WITHHELD_FUNDS) {
        url += `&date=${ formattedDate }`;
      }

      crudActions.get(url)
        .then((response) => {
          if (controls.dataType === DATA_TYPES.RUNNING_BALANCE) {
            this.setState({
              runningBalanceValues: response,
              showSecondPanel: true,
              savedData: Object.assign({ ...controls.data() }, {
                date: formattedDate,
                baseCurrencies:
                    companiesBaseCurrencies[controls.company] || [],
              }),
              loadingDataInput: false,
              lockButton: false,
            });
          } else if (controls.dataType === DATA_TYPES.WITHHELD_FUNDS) {
            Object.assign(controls, {
              date: formattedDate,
              currency: mids && mids.find(item => item.value === Number(controls.midIds)).currency
            });
            this.setState({
              withheldFunds: response,
              showSecondPanel: true,
              controls: controls,
              loadingDataInput: false,
              lockButton: false
            });
          }
        })
        .catch((err) => {
          this.showErrorAlert(err ? err.message : '');
        });
    }
  };

  getFxPairValue = (fxPair) => {
    return fxPair.split("/")[0] === fxPair.split("/")[1] ? fxPair.split("/")[1] : fxPair;
  };

  onMidSelect = (index, dataType) => {
    const { savedData } = this.state;
    const settlementFormName = this.formsMap[savedData.dataType];
    const midsKey = `${settlementFormName}Mids`;
    const totalKey = `${settlementFormName}Total`;
    const otcKey = `${settlementFormName}Otc`;
    const settlementForm = this.state[totalKey];
    let settlementMids = this.state[midsKey];

    if (settlementMids[index].availableBalance <= 0 ||
      ((savedData.dataType === DATA_TYPES.OTC_SETTLEMENT || savedData.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) && this.availableCollectedFunds(settlementMids, index) <= 0)) {
      return;
    }

    const checkedState = settlementMids[index].isChecked;
    settlementMids[index].isChecked = !checkedState;

    if (settlementMids[index].isChecked) {
      if (settlementForm.requestedSettlement !== "") {
        if (
          parseFloat(settlementForm.balanceToSettle.toFixed(2)) < parseFloat(parseFloat(settlementForm.requestedSettlement).toFixed(2))
        ) {
          const diff = parseFloat(parseFloat(settlementForm.requestedSettlement).toFixed(2)) - parseFloat(settlementForm.balanceToSettle.toFixed(2));
          if (diff > settlementMids[index].availableBalance && savedData.dataType !== DATA_TYPES.OTC_SETTLEMENT && savedData.dataType !== DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST ) {
            settlementMids[index].balanceToSettle = parseFloat(settlementMids[index].availableBalance.toFixed(2));
            settlementForm.balanceToSettle = parseFloat(settlementForm.balanceToSettle.toFixed(2)) + parseFloat(settlementMids[index].availableBalance.toFixed(2));
          } else if ((savedData.dataType === DATA_TYPES.OTC_SETTLEMENT || savedData.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) && diff > Math.min(this.availableCollectedFunds(settlementMids, index), settlementMids[index].availableBalance) ) {
            const actualBalance = Math.min(this.availableCollectedFunds(settlementMids, index), settlementMids[index].availableBalance);
            settlementMids[index].balanceToSettle = parseFloat(actualBalance.toFixed(2));
            settlementForm.balanceToSettle = parseFloat(settlementForm.balanceToSettle.toFixed(2)) + parseFloat(actualBalance.toFixed(2));
            if (this.availableCollectedFunds(settlementMids, index) === settlementForm.balanceToSettle) {
              settlementMids = this.disableOtherZeroBalanceMids(settlementMids, index, savedData.dataType);
            }
          } else {
            const balanceDiff = Math.abs(
              parseFloat(settlementForm.balanceToSettle.toFixed(2)) -
                parseFloat(parseFloat(settlementForm.requestedSettlement).toFixed(2))
            );
            settlementMids[index].balanceToSettle = parseFloat(balanceDiff.toFixed(2));
            settlementForm.balanceToSettle = parseFloat(settlementForm.balanceToSettle.toFixed(2)) + parseFloat(balanceDiff.toFixed(2));
            for (let i = 0; i < settlementMids.length; i++) {
              settlementMids[i].disabled = settlementMids[i].balanceToSettle === 0;
            }
          }
        } else {
          for (let i = 0; i < settlementMids.length; i++) {
            settlementMids[i].disabled = settlementMids[i].balanceToSettle === 0;
          }
        }
      } else {
        settlementMids[index].balanceToSettle = (dataType !== DATA_TYPES.OTC_SETTLEMENT && savedData.dataType !== DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) ? parseFloat(settlementMids[index].availableBalance.toFixed(2))
          : Math.min(parseFloat(settlementMids[index].availableBalance.toFixed(2)), parseFloat(this.availableCollectedFunds(settlementMids, index).toFixed(2)));
        let sumToSettle = 0;
        for (let i = 0; i < settlementMids.length; i++) {
          if (settlementMids[i].balanceToSettle) {
            sumToSettle += parseFloat(parseFloat(settlementMids[i].balanceToSettle).toFixed(2));
          }
        }
        settlementForm.balanceToSettle = parseFloat(sumToSettle.toFixed(2));
        if (this.availableCollectedFunds(settlementMids, index) === settlementMids[index].balanceToSettle) {
          settlementMids = this.disableOtherZeroBalanceMids(settlementMids, index, savedData.dataType);
        }
      }
      this.changeRequestedSettlementFieldStatus(dataType, true);
    } else {
      settlementMids[index].balanceToSettle = 0;
      let sumToSettle = 0;
      for (let i = 0; i < settlementMids.length; i++) {
        settlementMids[i].disabled = false;
        sumToSettle += parseFloat(parseFloat(settlementMids[i].balanceToSettle).toFixed(2));
        if ((dataType === DATA_TYPES.OTC_SETTLEMENT || dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) && !settlementMids[i].balanceToSettle) {
          const available = parseFloat(this.availableCollectedFunds(settlementMids, i).toFixed(2));
          settlementMids[i].disabled = available === 0;
          if (savedData.dataType === DATA_TYPES.OTC_SETTLEMENT) {
            this.fieldsMap[dataType][i] = this.updateFiledRule(this.fieldsMap[dataType][i], "balanceToSettle",
              "disabled", settlementMids[i].disabled);
          }
        }
      }
      settlementForm.balanceToSettle = parseFloat(sumToSettle.toFixed(2));
      if (settlementForm.balanceToSettle === 0 && dataType !== DATA_TYPES.SETTLEMENT_BY_DATE) {
        this.changeRequestedSettlementFieldStatus(dataType, false);
      }
    }

    const nextState = {
      [midsKey]: settlementMids,
      [totalKey]: settlementForm,
    };

    if (dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) {
      const otcForm = this.state[otcKey];
      const exchanged = settlementForm.balanceToSettle / otcForm.fxRate;
      otcForm.settlementFee = exchanged * (otcForm.settlementFeeValue / 100);
      otcForm.otcSettlement = exchanged - otcForm.settlementFee;
      nextState[otcKey] = otcForm;
    }

    this.setState(nextState);
  };

  disableOtherZeroBalanceMids = (settlementMids, index, dataType) => {
    for (let i = 0; i < settlementMids.length; i++) {
      if (
        settlementMids[i].pspAccountId === settlementMids[index].pspAccountId &&
        i !== index &&
        settlementMids[i].balanceToSettle === 0
      ) {
        settlementMids[i].disabled = true;
        if (dataType === DATA_TYPES.OTC_SETTLEMENT) {
          this.fieldsMap[dataType][i] =
            this.updateFiledRule(this.fieldsMap[dataType][i], "balanceToSettle", "disabled", settlementMids[i].disabled);
        }
      }
    }
    return settlementMids;
  };

  availableCollectedFunds = (settlementMids, index) => {
    const pspAccountId = settlementMids[index].pspAccountId;
    const sum = settlementMids.filter((s, i) => {
      if (index === i) {
        return false;
      } else {
        return s.pspAccountId === pspAccountId;
      }
    }
    ).reduce((acc, item) => acc + (item.balanceToSettle ? parseInt(item.balanceToSettle) : 0), 0);
    return settlementMids[index].collectedFunds - sum;
  };

  changeRequestedSettlementFieldStatus = (dataType, status) => {
    const fields = this.fieldsMap[dataType];

    if (dataType === DATA_TYPES.SETTLEMENT_BY_AMOUNT || dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST || dataType === DATA_TYPES.OTC_SETTLEMENT) {
      fields.forEach(subArray => {
        const fieldToUpdate = subArray.find(field => field.name === "requestedSettlement");

        if (fieldToUpdate) {
          fieldToUpdate.disabled = status;
        }
      });
    }
  };

  filterMids = (psp, merchant, method, currency) => {
    const { controls, mids, payoutMids } = this.state;
    const isPayoutTopUpRequest = controls.dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST;
    if (!psp && (!controls.psp || !controls.merchant ||
      (isPayoutTopUpRequest && !merchant))) {
      return [];
    }
    psp = !psp ? controls.psp : psp;
    merchant = !merchant ? controls.merchant : merchant;

    let filteredMidsByMerchant = (isPayoutTopUpRequest ? payoutMids : mids).filter(
      (mid) =>
        mid.clients.some(
          (client) => client.clientId === parseInt(merchant, 10)
        )
    );

    if (isPayoutTopUpRequest) {
      filteredMidsByMerchant = filteredMidsByMerchant.filter(
        (mid) => mid.currency === controls.currency
      );
      if (method) {
        filteredMidsByMerchant = filteredMidsByMerchant.filter(
          (mid) => mid.method === method
        );
      }
    }

    if (currency) {
      filteredMidsByMerchant = filteredMidsByMerchant.filter(
        (mid) => mid.currency === currency
      );
    }

    return filteredMidsByMerchant.filter(
      (mid) => typeof psp !== "string" ?
        psp.includes(mid.pspId.toString()) :
        psp === mid.pspId.toString()
    );
  };

  filterMidsByCurrency = () => {
    const { controls, mids } = this.state;
    if (!controls.merchant) {
      return [];
    }
    return mids.filter(
      (mid) =>
        mid.clients.some(
          (client) => client.clientId === parseInt(controls.merchant, 10)
        ) && mid.currency === controls.currency
    );
  };

  onTypesTemporaryChange = (temporaryItem) => {
    this.setState({
      temporaryRunningBalanceItem: temporaryItem
    });
  };

  onTypesChange = (selectedItems) => {
    if (selectedItems) {
      this.setState({
        runningBalanceValues: selectedItems,
      });
    }
  };

  onWithheldTemporaryChange = (temporaryItem) => {
    this.setState({
      temporaryWithheldItem: temporaryItem
    });
  };

  onWithheldChange = (funds) => {
    this.setState({
      withheldFunds: funds
    });
  };

  checkPageAccess = (permissionName) => {
    const { access } = this.state;
    const foundPermission = access.find(
      (elem) => elem.permission === permissionName
    );
    if (!foundPermission) {
      return false;
    }

    return foundPermission.state;
  };

  mapSelectedItems = (type, key, obj) => {
    const field = this.state.controls[type];
    const selected = this.state[obj];
    const lookup = selected[key];

    return !field ? [] : field?.map((elem) => {
      return lookup.find((lookupElem) => elem === lookupElem.value || elem === lookupElem.id);
    });
  };

  mapSelectedMids = () => {
    const { controls, mids } = this.state;
    return controls.midIds
      ? mids.filter((elem) => controls.midIds.indexOf(elem.value) > -1)
      : [];
  };

  onSaveDataEntries = () => {
    const { savedData, runningBalanceValues, temporaryRunningBalanceItem,
      temporaryWithheldItem, withheldFunds } = this.state;

    if (savedData.dataType === DATA_TYPES.RUNNING_BALANCE) {
      if (temporaryRunningBalanceItem.id && temporaryRunningBalanceItem.value) {
        runningBalanceValues.push(temporaryRunningBalanceItem);
      }

      this.setState({
        lockButton: true,
        loadingDataInput: true
      });

      crudActions
        .put(`v1/data/input`, {
          data: runningBalanceValues,
          clientId: savedData.merchant,
          midId: savedData.midIds,
          date: savedData.date,
        })
        .then(() => {
          this.updateStateAfterSuccessSave("Settlement successfully initiated.");
          this.setState({ temporaryRunningBalanceItem: {} });
        })
        .catch((err) => {
          this.showErrorAlert(err ? err.message : '');
        });
    } else if (savedData.dataType === DATA_TYPES.WITHHELD_FUNDS) {
      if (temporaryWithheldItem.amount) {
        withheldFunds.push(temporaryWithheldItem);
        this.setState({
          temporaryWithheldItem: {}
        });
      }

      if (withheldFunds) {
        withheldFunds.forEach(fund => {
          if (!fund.clientId) {
            fund.clientId = Number(savedData.merchant);
          }
          if (!fund.midId) {
            fund.midId = Number(savedData.midIds);
          }
        });
      }

      this.setState({
        lockButton: true,
        loadingDataInput: true
      });

      crudActions.post(`v1/data/input/withheld-funds`, withheldFunds)
        .then(() => {
          this.updateStateAfterSuccessSave("Operation successful.");
        })
        .catch((err) => {
          this.showErrorAlert(err ? err.message : '');
        });
    }
  };

  updateState = (newState) => {
    this.setState(prevState => ({
      ...prevState,
      ...newState
    }));
  };

  updateField = (name, value) => {
    this.fieldsMap[name] = value;
    this.setState(prev => ({ dummy: !prev.dummy }));
  };

  updateStateAfterOnSaveValidation = (form, isFormValid, isValid) => {
    const { dataType } = this.state.savedData;
    const formName = this.formsMap[dataType];
    this.setState({
      saveClicked: true,
      [formName]: form,
      lockButton: isFormValid,
      loadingDataInput: isValid
    });
  };

  updateStateAfterOnChangeValidation = (controls, isFormValid) => {
    this.setState({
      controls: controls,
      submitClicked: true,
      lockButton: isFormValid,
      loadingDataInput: isFormValid,
    });
  };

  updateStateAfterSuccessSave = (message, withoutReset) => {
    const { pageType, companies, controlsFormData, controlsFormRules } = this.state;

    this.props.showAlert(
      true,
      "success",
      message,
      () => {
        if (!withoutReset) {
          this.setState({
            showSecondPanel: false,
            showThirdPanel: false,
            savedData: {},
            saveClicked: false
          });
        }
      }
    );
    this.setState({
      lockButton: false,
      loadingDataInput: false,
    });
    if (!withoutReset) {
      const controls = pageType === "incomingFunds" ? this.defineControlsForm(this.state.controls.dataType) : pageType === "otcSettlements" ? this.defineControlsForm(this.state.controls.dataType) : new Form(controlsFormData, controlsFormRules);

      this.setState({
        controls: Object.assign(controls, {
          company: companies[0] ? companies[0].value : "",
        }),
      });
    }
  };

  showErrorAlert = (message, typeAlert) => {
    if (message) {
      this.props.showAlert(true, typeAlert ? typeAlert : "error", message);
    }

    this.setState({
      lockButton: false,
      loadingDataInput: false
    });
  };

  isDateValid = (current) => {
    const { dateNow, lastSettlementDate, controls } = this.state;

    if ( lastSettlementDate && controls.dataType === DATA_TYPES.SETTLEMENT_BY_DATE) {
      return current.isBetween(lastSettlementDate, dateNow, undefined, '[]');
    }

    return current.isBefore(dateNow);
  };

  getTXValue = (midId) => {
    const { controls, mids } = this.state;
    const mid = mids.find(elem => elem.value === midId);
    const client = mid && mid.clients ? mid.clients.find(item => item.clientId === parseInt(controls.merchant)) : undefined;
    return client ? client.tx : '';
  };

  filterFields = (rowArray, type, element) => {
    let finishedArray = [];

    if (type === DATA_TYPES.UPDATE_SETTLEMENT) {
      finishedArray = rowArray.map((elem) => {
        if (elem.display && !element[elem.name]) {
          return { fieldType: "empty" };
        }

        if (element["toDate"] && element["fromDate"] && elem.name === "date") {
          return { fieldType: "empty" };
        }

        return elem;
      });
      finishedArray.reverse();

      return finishedArray.reduce((accum, currVal) => {
        if (!currVal.fieldType || currVal.fieldType === "empty") {
          accum.push(currVal);
        } else {
          accum.unshift(currVal);
        }

        return accum;
      }, []);
    } else {
      return rowArray;
    }
  };

  getUniqueData = () => {
    const { settlementDates } = this.state;

    if (!settlementDates) {
      return null;
    }

    return Array.from(new Set(settlementDates.map(obj => obj.value)))
      .map(value => {
        return settlementDates.find(obj => obj.value === value);
      });
  };

  getMidsOptions = () => {
    const { controls } = this.state;
    if (controls.dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST || controls.dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST ||
        controls.dataType === DATA_TYPES.UPDATE_SETTLEMENT) {
      return this.filterMidsByCurrency();
    } else if (
      controls.dataType === DATA_TYPES.SETTLEMENT_BY_AMOUNT ||
      controls.dataType === DATA_TYPES.SETTLEMENT_BY_DATE
    ) {
      return this.filterMidsByPSPAndCurrency(controls);
    } else {
      return this.filterMids();
    }
  };

  filterMidsByPSPAndCurrency = (controls) => {
    const { mids } = this.state;
    if (!controls.psp || !controls.merchant) {
      return [];
    }

    return mids.filter(
      (mid) =>
        mid.clients.some(
          (client) => client.clientId === parseInt(controls.merchant, 10)
        ) && controls["psp"].includes(mid.pspId.toString())
    ).filter(
      (mid) =>
        mid.clients.some(
          (client) => client.clientId === parseInt(controls.merchant, 10)
        ) && mid.currency === controls.currency
    );
  };

  filterDataTypes = () => {
    const { dataTypes, pageType, otcActionType, companiesRBChangesAllowed, controls, otcSettlementsActionType,  isOtcSettlements } = this.state;

    let filtered = [...dataTypes];

    if (pageType === "incomingFunds") {
      return otcActionType;
    }
    if (isOtcSettlements) {
      return otcSettlementsActionType;
    }

    if (!companiesRBChangesAllowed[controls.company]) {
      filtered = filtered.filter(type => type.value !== DATA_TYPES.RUNNING_BALANCE);
    }

    const supportedApplicationType = "APM";
    return filtered.filter(type => type.supportedBy.includes(supportedApplicationType));
  };

  filterMerchants = () => {
    const { companiesClients, controls } = this.state;
    if (!controls.company) return [];

    if (controls.dataType === DATA_TYPES.DEBIT_CREDIT) {
      return companiesClients[controls.company].filter(client => !client.isSandbox);
    }

    return companiesClients[controls.company];
  };

  onAutoCredit = (index) => {
    const { debitCreditForm } = this.state;
    const debitCreditFormSingle = debitCreditForm[index];
    if (!debitCreditFormSingle.creditAmount || debitCreditFormSingle.creditAmount !== debitCreditFormSingle.debitBalance) {
      debitCreditFormSingle.creditAmount = debitCreditFormSingle.debitBalance > 0 && this.isDebitAutoAvailable(debitCreditFormSingle.debitMidId, index) ? debitCreditFormSingle.debitBalance : debitCreditFormSingle.creditAmount;
    } else {
      debitCreditFormSingle.creditAmount = "";
    }
    debitCreditFormSingle.isChecked = !debitCreditFormSingle.isChecked;
    this.setState({
      debitCreditForm: debitCreditForm,
    });
  };

  onAutoCashout = (index) => {
    const { otcCashoutForm, savedData } = this.state;
    const otcCashoutFormSingle = otcCashoutForm[index];
    const fxPairArray = savedData.fxPair.split("/");
    const isFxRateFixed = fxPairArray[0] === fxPairArray[1];
    if (!otcCashoutFormSingle.isChecked) {
      otcCashoutFormSingle.requestedBalance = otcCashoutFormSingle.availableBalance;
      if (otcCashoutFormSingle.incomingFunds && otcCashoutFormSingle.fxRate) {
        otcCashoutFormSingle.incomingFunds = "";
        otcCashoutFormSingle.fxRate = "";
        this.fieldsMap.OTC_CASHOUT[index] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[index], "requestedBalance",
          "disabled", false);
      }
    } else {
      const fieldNameToUpdate = "disabled";
      const fxRateDisabled = this.getFiledRule(this.fieldsMap.OTC_CASHOUT[index], "fxRate", fieldNameToUpdate);
      if (fxRateDisabled && !isFxRateFixed) {
        otcCashoutFormSingle.fxRate = "";
      }
      const incomingFundsDisabled = this.getFiledRule(this.fieldsMap.OTC_CASHOUT[index], "incomingFunds", fieldNameToUpdate);
      if (incomingFundsDisabled) {
        otcCashoutFormSingle.incomingFunds = "";
      }
      otcCashoutFormSingle.requestedBalance = "";
    }
    otcCashoutFormSingle.isChecked = !otcCashoutFormSingle.isChecked;
    if (!isFxRateFixed) {
      if (otcCashoutFormSingle.fxRate && !otcCashoutFormSingle.incomingFunds) {
        this.fieldsMap.OTC_CASHOUT[index] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[index], "incomingFunds",
          "disabled", otcCashoutFormSingle.isChecked);
      } else if(!otcCashoutFormSingle.fxRate && otcCashoutFormSingle.incomingFunds) {
        this.fieldsMap.OTC_CASHOUT[index] = this.updateFiledRule(this.fieldsMap.OTC_CASHOUT[index], "fxRate",
          "disabled", otcCashoutFormSingle.isChecked);
      }
    }
    this.reCalculateIncomingFunds(otcCashoutForm);
    this.reCalculateFxRate(otcCashoutForm, index);
    this.reCalculateAllIncomingFunds(otcCashoutForm);
    this.reCalculateAllRequestedBalance(otcCashoutForm);
    this.setState({
      otcCashoutForm: otcCashoutForm,
    });
  };

  onAutoGeneral = (index, sourceField, targetField, form) => {
    const formValue = this.state[form];
    const otcWithdrawalFormRow = formValue[index];
    if (!otcWithdrawalFormRow.isChecked) {
      otcWithdrawalFormRow[targetField] = otcWithdrawalFormRow[sourceField];
    } else {
      otcWithdrawalFormRow[targetField] = "";
    }
    otcWithdrawalFormRow.isChecked = !otcWithdrawalFormRow.isChecked;
    this.setState({
      [form]: formValue
    });
  };

  onOtcSelect = (index) => {
    const { otcSettlementForm } = this.state;
    const otcSettlementFormSingle = otcSettlementForm[index];
    this.fieldsMap.OTC_SETTLEMENT[index] = this.updateFiledRule(this.fieldsMap.OTC_SETTLEMENT[index], "withOtc",
      "disabled", !otcSettlementFormSingle.withOtc);

    otcSettlementFormSingle.withOtc = !otcSettlementFormSingle.withOtc;
    this.setState({
      otcSettlementForm: otcSettlementForm,
    });
  };

  isDebitAutoAvailable = (midId, indx) => {
    const { debitCreditForm } = this.state;
    return debitCreditForm.filter((form, idx)  => idx !== indx && form.debitMidId === midId && form.creditAmount).length === 0;
  };

  isCreditDebit = () => {
    const { savedData } = this.state;
    return savedData.dataType === DATA_TYPES.DEBIT_CREDIT;
  };

  filterAccountsByFxPairAndSelect = (accounts, fxPair, pspIds) => {
    return accounts.filter(account => (account.fxPair === fxPair || (account.currency === fxPair.split("/")[0] && account.currency === fxPair.split("/")[1]))
      && pspIds.includes(account.pspId.toString()));
  };

  filterAccountsByCurrencyAndSelect = (accounts, currency, pspIds) => {
    return accounts.filter(account => account.currency === currency && pspIds.includes(account.pspId.toString()));
  };

  filterAndMapFxPairs = (fxPairs, pspIds, accounts, currency) => {
    const accountsFxPairs = [...new Set(
      accounts
        .filter(account => pspIds.includes(account.pspId.toString()))
        .filter(account => account.currency === currency)
        .filter(account => account.fxPair)
        .map(account => account.fxPair)
    )];
    return fxPairs.filter(elem => accountsFxPairs.includes(elem) || elem.split("/")[0] === elem.split("/")[1]).map((pair) => {
      return { value: pair, label: this.getFxPairValue(pair) };
    });
  };

  getTitle = (dataType) => {
    switch (dataType) {
    case DATA_TYPES.OTC_CASHOUT:
    case DATA_TYPES.OTC_CASHOUT_UPDATE:
    case DATA_TYPES.PAYOUT_TOP_UP:
      return "Inbound Settlement";
    case DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST:
    case DATA_TYPES.OTC_SETTLEMENT:
      return "OTC Settlements";
    default:
      return "Data Input";
    }
  };

  callOnSaveDataEntries = () => {
    if (this.dataTypeComponentRef.current) {
      this.dataTypeComponentRef.current.onSaveDataEntries();
    } else {
      this.onSaveDataEntries();
    }
  };

  callOnChangeFilter = () => {
    const { controls } = this.state;
    if (this.dataTypeComponentRef.current) {
      this.dataTypeComponentRef.current.onChangeFilter();
    } else {
      this.onChangeFilter();
    }
    this.setState({
      savedData: { ...controls }
    });
    this.updateFxPair();
  };

  updateFxPair = () => {
    const { controls, companiesFxPairs } = this.state;
    this.setState({
      fxPairs: companiesFxPairs[controls.company].filter(elem => elem.split("/")[1] === controls.currency).map((pair) => {
        return { value: pair, label: this.getFxPairValue(pair) };
      })
    });
  };

  handleConfirmPromptModal = () => {
    const { controls } = this.state;
    if (this.dataTypeComponentRef.current && controls.dataType === DATA_TYPES.DEBIT_CREDIT) {
      this.dataTypeComponentRef.current.onSaveDataEntries(true);
    }
  };
  
  handleClosePromptModal = () => {
    this.setState({
      showPromptModal: false
    });
  };

  getComponent = (dataType) => {
    switch (dataType) {
    case DATA_TYPES.SETTLEMENT_BY_AMOUNT:
      return SettlementByAmountComponent;
    case DATA_TYPES.SETTLEMENT_BY_REQUEST:
      return SettlementByRequestComponent;
    case DATA_TYPES.SETTLEMENT_BY_DATE:
      return SettlementByDateComponent;
    case DATA_TYPES.UPDATE_SETTLEMENT:
      return UpdateSettlementComponent;
    case DATA_TYPES.OTC_CASHOUT:
      return OtcCashoutComponent;
    case DATA_TYPES.PAYOUT_TOP_UP:
      return PayoutTopUpComponent;
    case DATA_TYPES.OTC_CASHOUT_UPDATE:
      return OtcCashoutUpdateComponent;
    case DATA_TYPES.DEBIT_CREDIT:
      return DebitCreditComponent;
    case DATA_TYPES.TOP_UP_PAYOUT_WALLET:
      return TopUpPayoutWalletComponent;
    case DATA_TYPES.SETTLE_AGENT:
      return SettleAgentComponent;
    case DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST:
      return OtcSettlementByRequestComponent;
    case DATA_TYPES.OTC_SETTLEMENT:
      return OtcSettlementComponent;
    case DATA_TYPES.OTC_WITHDRAWAL:
      return OtcWithdrawalComponent;
    case DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST:
      return OtcWithdrawalByRequestComponent;
    case DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST:
      return TopUpByRequestComponent;
    default:
      return null;
    }
  };

  getStatusesByDataType = (dataType) => {
    switch (dataType) {
    case DATA_TYPES.SETTLEMENT_BY_AMOUNT:
    case DATA_TYPES.SETTLEMENT_BY_DATE:
      return this.state.settlementByAmountStatuses;
    case DATA_TYPES.OTC_SETTLEMENT:
      return this.state.otcSettlementStatuses;
    case DATA_TYPES.SETTLEMENT_BY_REQUEST:
      return this.state.settlementByRequestStatuses;
    case DATA_TYPES.UPDATE_SETTLEMENT:
      return this.state.updateSettlementStatuses;
    case DATA_TYPES.OTC_CASHOUT:
    case DATA_TYPES.OTC_CASHOUT_UPDATE:
      return this.state.otcCashoutStatuses.filter(status => status.value !== DATA_TYPES.PAYOUT_TOP_UP);
    case DATA_TYPES.PAYOUT_TOP_UP:
      return this.state.otcCashoutStatuses.filter(status => status.value === DATA_TYPES.PAYOUT_TOP_UP);
    case DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST:
      return this.state.otcSettlementByRequestStatuses;
    default :
      return [];
    }
  };

  getAutoFunctionByDataType = (dataType) => {
    switch (dataType) {
    case DATA_TYPES.DEBIT_CREDIT:
      return this.onAutoCredit;
    case DATA_TYPES.OTC_CASHOUT:
      return this.onAutoCashout;
    case DATA_TYPES.OTC_SETTLEMENT:
      return this.onOtcSelect;
    case DATA_TYPES.PAYOUT_TOP_UP:
    case DATA_TYPES.OTC_WITHDRAWAL:
      return this.onAutoGeneral;
    default :
      return [];
    }
  };

  getActionPanel = (selectedForm, dataType, fields, settlementMids, title) => {
    const { lockButton } = this.state;
    const fullForm = selectedForm;

    return <Panel>
      <Panel.Heading>
        <Panel.Title> { title } </Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        <div className="panel-content amount-form" style={ { overflow: "unset" } }>
          { fields.map((rowArray, index) => {
            if (![DATA_TYPES.TOP_UP_PAYOUT_WALLET, DATA_TYPES.SETTLE_AGENT].includes(dataType)) {
              selectedForm = fullForm[index];
            }
            if (index < fullForm.length || this.checkPageAccess("DATA_INPUT_WRITE")) {
              return (
                <FormRow
                  key={ index }
                  rowArray={ rowArray }
                  filterFields={ this.filterFields }
                  collapsInputsLabels={ index < settlementMids.length ||  DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST === dataType }
                  onSaveDataEntries={ this.callOnSaveDataEntries }
                  onValueChange={ !this.isCreditDebit() ? this.onSettlementChange : this.onCreditDebitChange }
                  lockButton={ lockButton }
                  index={ index }
                  rowForms={ selectedForm }
                  dataType={ dataType }
                />
              );
            } else {
              return <></>;
            }}) }
        </div>
      </Panel.Body>
    </Panel>;
  };

  renderDataTypeComponent = (dataType, selectedForm) => {
    const { controls, companiesAccounts, companiesPsps, midsFiltered, savedData, settlementMids, date } = this.state;
    const DataTypeComponent = this.getComponent(dataType);

    if (!DataTypeComponent) return null;
    return (
      <DataTypeComponent
        ref={ this.dataTypeComponentRef }
        companiesAccounts={ companiesAccounts }
        companiesPsps = { companiesPsps }
        controls={ controls }
        date={ date }
        fields={ this.fieldsMap[dataType] }
        filterMids={ this.filterMids }
        form={ selectedForm }
        formState={ this.state[this.formsMap[dataType] + "Total"] }
        formTotal={ this.state[this.formsMap[dataType] + "Total"] }
        getOptionsFromState={ this.getOptionsFromState }
        getTXValue={ this.getTXValue }
        midsFiltered={ midsFiltered }
        noWriteAccess={ !this.checkPageAccess("DATA_INPUT_WRITE") }
        onAutoFunction={ this.getAutoFunctionByDataType(dataType) }
        onMidSelect={ this.onMidSelect }
        savedData={ savedData }
        settlementMids={ settlementMids }
        showErrorAlert={ this.showErrorAlert }
        statuses={ this.getStatusesByDataType(dataType) }
        updateField={ this.updateField }
        updateState={ this.updateState }
        updateStateAfterOnChangeValidation={ this.updateStateAfterOnChangeValidation }
        updateStateAfterOnSaveValidation={ this.updateStateAfterOnSaveValidation }
        updateStateAfterSuccessSave={ this.updateStateAfterSuccessSave }
        loadOtcWallets={ this.loadOtcWallets }
      />
    );
  };

  render() {
    const {
      companies,
      companiesBaseCurrencies,
      companiesAccounts,
      companiesPsps,
      companiesWalletCurrencies,
      controls,
      date,
      filteredFxPairs,
      firstPanelLength,
      loadingDataInput,
      loadingLookups,
      lockButton,
      otcCashoutInvoiceDates,
      otcCashoutCurrencies,
      pageType,
      promptMessage,
      runningBalanceTypes,
      runningBalanceValues,
      savedData,
      settlementStatuses,
      settlementMids,
      settlementsForDate,
      showPromptModal,
      showSecondPanel,
      showThirdPanel,
      withheldFunds
    } = this.state;

    const selectedForm = this.state[this.formsMap[savedData.dataType]];

    const dataType = savedData && savedData.dataType && showSecondPanel ? savedData.dataType : controls.dataType;

    const isIncomingFunds = pageType === "incomingFunds";
    const isOtcSettlements = pageType === "otcSettlements";

    const displayMerchantSelect =  dataType !== DATA_TYPES.SETTLE_AGENT && pageType !== "incomingFunds";

    const displayCurrencySelect = dataType === DATA_TYPES.SETTLEMENT_BY_AMOUNT || dataType === DATA_TYPES.SETTLEMENT_BY_DATE ||
      dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST || dataType === DATA_TYPES.UPDATE_SETTLEMENT;

    const displayPSPMultiselect = dataType === DATA_TYPES.SETTLEMENT_BY_AMOUNT || dataType === DATA_TYPES.SETTLEMENT_BY_DATE || dataType === DATA_TYPES.OTC_SETTLEMENT;

    const displayPSPSelect = pageType === "settlements" && (dataType === "" || dataType === DATA_TYPES.RUNNING_BALANCE
      || dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET || dataType === DATA_TYPES.WITHHELD_FUNDS || dataType === DATA_TYPES.DEBIT_CREDIT);

    const dataTypesForMultiMerchant = [
      DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST,
      DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST
    ];

    const currencyColumn = (
      <Column
        flexGrow={ 1 }
        vertical="start"
        alignSelf="start"
        className="input-column"
      >
        <label> Currency </label>
        <Select
          id="currency"
          name="currency"
          value={ controls.currency || "" }
          className={ controls.errors?.has("currency") ? "error-field" : "" }
          required={ true }
          clearable={ false }
          onChange={ (value) =>
            this.onValueChange(value, "currency")
          }
          options={ companiesBaseCurrencies[controls.company] }
        />
      </Column>
    );

    const singleProviderColumn = (
      <Column
        flexGrow={ 1 }
        vertical="start"
        alignSelf="start"
        className="input-column"
      >
        <label> Provider </label>
        <Select
          id="psp"
          name="psp"
          value={ controls.psp || "" }
          className={ controls.errors?.has("psp") ? "error-field" : "" }
          required={ true }
          clearable={ false }
          disabled={ !controls.company }
          onChange={ (value) => this.onValueChange(value, "psp") }
          options={ controls.company ? companiesPsps[controls.company] : [] }
        />
      </Column>
    );

    const multiSelectProviderColumn = displayPSPMultiselect || isIncomingFunds ?  (
      <Column
        flexGrow={ 1 }
        vertical="start"
        alignSelf="start"
        className="input-column"
      >
        <label> Provider </label>
        <Multiselect
          id="psp"
          name="psp"
          isError={ controls.errors?.has("psp") }
          selectedItems={ this.mapSelectedItems("psp", controls.company, "companiesPsps") }
          className={ controls.errors?.has("psp") ? "error-field" : "" }
          required={ true }
          clearable={ false }
          disabled={ !controls.company || (dataType === DATA_TYPES.OTC_SETTLEMENT &&  !controls.fxPair) }
          onChange={ (value) => this.onValueChange(value, "psp") }
          items={ controls.company ? companiesPsps[controls.company] : [] }
        />
      </Column>
    ) : <></>;

    return (
      <Row flexGrow={ 1 } className="module apidata settlements" vertical="start">
        { this.renderDataTypeComponent(dataType, selectedForm) }
        <Column flexGrow={ 1 }>
          <PageHeader
            title={ this.getTitle(dataType) }
            lastUpdate={ this.state.lastUpdate }
            img={ ManualInputIcon }
          />
          <Row flexGrow={ 1 } horizontal="start" wrap={ true } vertical="start">
            <Column
              flexGrow={ 1 }
              vertical="start"
              style={ { paddingLeft: 15, paddingRight: 15, paddingTop: 15, width: "100%" } }
            >
              <Panel>
                <Panel.Heading>
                  <Panel.Title>SELECT</Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  {loadingLookups ? (
                    <div
                      style={ { width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center" } }
                    >
                      <Spinner smallContainer={ true } />
                    </div>
                  ) : (
                    <div className="panel-content" style={ { overflow: "unset" } }>
                      <Row
                        flexGrow={ 1 }
                        wrap={ true }
                        horizontal="start"
                        vertical="end"
                        style={ { width: "100%" } }
                      >
                        {/* WHITE LABEL */}

                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <label> White Label </label>
                          <Select
                            id="company"
                            name="company"
                            value={ controls.company || "" }
                            className={ controls.errors.has("company") ? "error-field" : "" }
                            required={ true }
                            clearable={ false }
                            onChange={ (value) => this.onValueChange(value, "company") }
                            options={ companies }
                          />
                        </Column>

                        {/* DATA TYPE */}

                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <label> { !isIncomingFunds && !isOtcSettlements ? "Data Type" : "Action Type" } </label>
                          <Select
                            id="dataType"
                            name="dataType"
                            value={ controls.dataType || "" }
                            className={ controls.errors.has("dataType") ? "error-field" : "" }
                            required={ true }
                            clearable={ false }
                            disabled={ !controls.company }
                            onChange={ (value) => this.onValueChange(value, "dataType") }
                            options={ this.filterDataTypes() }
                          />
                        </Column>

                        {/* MERCHANT */ }

                        {displayMerchantSelect && (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> Merchant </label>
                            { !dataTypesForMultiMerchant.includes(controls.dataType) ? (
                              <Select
                                id="merchant"
                                name="merchant"
                                value={ controls.merchant || "" }
                                className={ controls.errors.has("merchant") ? "error-field" : "" }
                                required={ true }
                                clearable={ false }
                                disabled={ !controls.company }
                                onChange={ (value) => this.onValueChange(value, "merchant") }
                                options={ this.filterMerchants() }
                              />
                            ) : (
                              <Multiselect
                                id="merchant"
                                name="merchant"
                                isError={ controls.errors?.has("merchant") }
                                selectedItems={ this.mapSelectedItems("merchant", controls.company, "companiesClients") }
                                className={ controls.errors?.has("merchant") ? "error-field" : "" }
                                required={ true }
                                clearable={ false }
                                disabled={ !controls.company }
                                onChange={ (value) => this.onValueChange(value, "merchant") }
                                items={ this.filterMerchants() }
                              />
                            )}
                          </Column>
                        ) }

                        {/* OTC Cashout Provider */}
                        {isIncomingFunds && (
                          <> { multiSelectProviderColumn } </>
                        )}

                        {/* AGENTS */ }

                        {dataType === DATA_TYPES.SETTLE_AGENT && (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> Agents </label>
                            <Select
                              id="agentId"
                              name="agentId"
                              value={ controls.agent || "" }
                              className={ controls.errors.has("agent") ? "error-field" : "" }
                              required={ true }
                              clearable={ false }
                              onChange={ (value) => this.onValueChange(value, "agent") }
                              options={ this.state.agents }
                            />
                          </Column>
                        )}

                        {/* DATE or STATUS */ }

                        {dataType === DATA_TYPES.SETTLEMENT_BY_DATE || dataType === DATA_TYPES.SETTLE_AGENT ? (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> Date </label>
                            <Datetime
                              type="text"
                              timeFormat={ dataType === DATA_TYPES.SETTLE_AGENT && "HH:mm" }
                              inputProps={ { onKeyDown: (e) => {e.preventDefault(); } } }
                              dateFormat="DD.MM.YYYY"
                              value={ controls.date || "" }
                              isValidDate={ (event) => this.isDateValid(event) }
                              onChange={ (event) => this.onValueChange({ value: Datetime.moment(event) }, "date") }
                              required={ true }
                            />
                          </Column>
                        ) : dataType === DATA_TYPES.UPDATE_SETTLEMENT ? (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> Status </label>
                            <Select
                              id="settlementStatus"
                              name="settlementStatus"
                              value={ controls.settlementStatus || "" }
                              className={ controls.errors.has("settlementStatus") ? "error-field" : "" }
                              required={ true }
                              clearable={ false }
                              onChange={ (value) => this.onValueChange(value, "settlementStatus") }
                              options={ settlementStatuses.filter((elem) => elem.label === "Cancelled" || elem.label === "Settled") }
                            />
                          </Column>
                        ) : dataType === DATA_TYPES.OTC_WITHDRAWAL || dataType === DATA_TYPES.OTC_CASHOUT || dataType === DATA_TYPES.PAYOUT_TOP_UP || dataType === DATA_TYPES.OTC_SETTLEMENT || dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST || dataType === DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST || dataType === DATA_TYPES.OTC_CASHOUT_UPDATE ? (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> Currency </label>
                            <Select
                              id="currency"
                              name="currency"
                              value={ controls.currency || "" }
                              className={ controls.errors.has("currency") ? "error-field" : "" }
                              required={ true }
                              clearable={ false }
                              onChange={ (value) => this.onValueChange(value, "currency") }
                              disabled={ (!controls.psp && dataType !== DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST && dataType !== DATA_TYPES.OTC_WITHDRAWAL && dataType !== DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST) || ((dataType === DATA_TYPES.OTC_SETTLEMENT || dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST  || dataType === DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST || dataType === DATA_TYPES.OTC_WITHDRAWAL) && !controls.merchant) }
                              options={ dataType === DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST ? companiesWalletCurrencies[controls.company] : otcCashoutCurrencies }
                            />
                          </Column>
                        ) : dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST || dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST || dataType === DATA_TYPES.DEBIT_CREDIT ? (
                          <> { currencyColumn } </>
                        ) : (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <span />
                          </Column>
                        )}
                      </Row>
                      <Row
                        flexGrow={ 1 }
                        wrap={ true }
                        horizontal="start"
                        vertical="end"
                        style={ { width: "100%" } }
                      >
                        {/* CURRENCY (optional) */}

                        {displayCurrencySelect && dataType !== DATA_TYPES.SETTLEMENT_BY_REQUEST && dataType !== DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST &&  (
                          <> { currencyColumn } </>
                        )}

                        {/* OTC Cashout Accounts && Fx Pair */}
                        {((isIncomingFunds && dataType === DATA_TYPES.OTC_CASHOUT) ||  dataType === DATA_TYPES.OTC_SETTLEMENT) && (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> FX Pair </label>
                            <Select
                              id="fxPair"
                              name="fxPair"
                              value={ controls.fxPair || "" }
                              className={ controls.errors.has("fxPair") ? "error-field" : "" }
                              disabled={ !controls.company || !controls.psp || !controls.currency }
                              required={ true }
                              clearable={ false }
                              onChange={ (value) => this.onValueChange(value, "fxPair") }
                              options={ filteredFxPairs }
                            />
                          </Column>
                        )}
                        {isIncomingFunds && (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> Accounts </label>
                            <Multiselect
                              id="accountIds"
                              name="accountIds"
                              isError={ controls.errors.has("accountIds") }
                              selectedItems={ this.mapSelectedItems("accountIds", controls.company, "companiesAccounts") }
                              className={ controls.errors.has("accountIds") ? "error-field" : "" }
                              required={ true }
                              clearable={ false }
                              disabled={ !controls.company || !controls.psp || (!controls.fxPair && dataType !== DATA_TYPES.OTC_CASHOUT_UPDATE && dataType !== DATA_TYPES.PAYOUT_TOP_UP) || (!controls.currency && dataType === DATA_TYPES.OTC_CASHOUT_UPDATE) }
                              onChange={ (value) => this.onValueChange(value, "accountIds") }
                              items={ controls.company && (controls.fxPair || dataType === DATA_TYPES.OTC_CASHOUT_UPDATE || dataType === DATA_TYPES.PAYOUT_TOP_UP) && controls.currency && controls.psp
                                ? dataType !== DATA_TYPES.OTC_CASHOUT_UPDATE && dataType !== DATA_TYPES.PAYOUT_TOP_UP ? this.filterAccountsByFxPairAndSelect(companiesAccounts[controls.company], controls.fxPair, controls.psp) : this.filterAccountsByCurrencyAndSelect(companiesAccounts[controls.company], controls.currency, controls.psp)
                                : [] }
                            />
                          </Column>
                        )}

                        {/* PSP */}

                        { displayPSPMultiselect && (
                          <> {  multiSelectProviderColumn } </>
                        )}

                        {displayPSPSelect && (
                          <> { singleProviderColumn } </>
                        )}

                        {/* MID */}

                        {!isIncomingFunds && dataType !== DATA_TYPES.OTC_WITHDRAWAL && dataType !== DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST && dataType !== DATA_TYPES.SETTLE_AGENT && dataType !== DATA_TYPES.DEBIT_CREDIT && dataType !== DATA_TYPES.OTC_SETTLEMENT && dataType !== DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST && (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> MID </label>
                            {(dataType !== "" &&
                              dataType !== DATA_TYPES.RUNNING_BALANCE &&
                              dataType !== DATA_TYPES.TOP_UP_PAYOUT_WALLET &&
                              dataType !== DATA_TYPES.WITHHELD_FUNDS) ? (
                                <Multiselect
                                  isError={ controls.errors.has("midIds") }
                                  selectedItems={ this.mapSelectedMids("midIds") }
                                  className={ controls.errors.has("midIds") ? "error-field" : "" }
                                  disabled={
                                    (dataType !== "" &&
                                      dataType !== DATA_TYPES.RUNNING_BALANCE &&
                                      dataType !== DATA_TYPES.TOP_UP_PAYOUT_WALLET)
                                      ? !controls.company ||
                                      !controls.merchant ||
                                      !controls.currency
                                      : !controls.company ||
                                      !controls.merchant ||
                                      !controls.psp
                                  }
                                  items={ this.getMidsOptions() }
                                  onChange={ (value) => this.onValueChange(value, "midIds") }
                                />
                              ) : (
                                <Select
                                  id="midIds"
                                  name="midIds"
                                  value={ controls.midIds || "" }
                                  className={ controls.errors.has("midIds") ? "error-field" : "" }
                                  required={ true }
                                  clearable={ false }
                                  disabled={ !controls.company || !controls.merchant || !controls.psp }
                                  onChange={ (value) => this.onValueChange(value, "midIds") }
                                  options={ this.filterMids() }
                                />
                              )}
                          </Column>
                        )}

                        {/* DATE (optional) */}

                        { dataType !== DATA_TYPES.SETTLEMENT_BY_AMOUNT &&
                          dataType !== DATA_TYPES.OTC_SETTLEMENT &&
                          dataType !== DATA_TYPES.SETTLEMENT_BY_DATE &&
                          dataType !== DATA_TYPES.SETTLE_AGENT &&
                          dataType !== DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST &&
                          dataType !== DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST &&
                          dataType !== DATA_TYPES.OTC_WITHDRAWAL && (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> Date </label>
                            {dataType === DATA_TYPES.UPDATE_SETTLEMENT || dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST || dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST ? (
                              <Select
                                id="date"
                                name="date"
                                value={ controls.updateSettlementDate || "" }
                                className={ controls.errors.has("updateSettlementDate") ? "error-field" : "" }
                                required={ true }
                                clearable={ false }
                                disabled={
                                  dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST || dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST
                                    ? (!controls.company ||
                                    !controls.merchant ||
                                    !controls.currency || !controls.midIds.length)
                                    : (!controls.company ||
                                    !controls.merchant ||
                                    !controls.settlementStatus ||
                                    !controls.currency ||
                                    !controls.midIds.length)
                                }
                                onChange={ (value) => this.onValueChange(value, "updateSettlementDate") }
                                options={ this.getUniqueData() }
                              />
                            ) : (dataType === DATA_TYPES.OTC_CASHOUT_UPDATE) ? (
                              <Select
                                id="date"
                                name="date"
                                value={ controls.date || "" }
                                className={ controls.errors.has("date") ? "error-field" : "" }
                                disabled={ !controls.currency || !controls.accountIds.length }
                                required={ true }
                                clearable={ false }
                                onChange={ (value) => this.onValueChange(value, "date") }
                                options={ otcCashoutInvoiceDates }
                              />
                            ) : (
                              <Datetime
                                type="text"
                                timeFormat={ false }
                                inputProps={ {
                                  onKeyDown: (e) => {
                                    e.preventDefault();
                                  },
                                  disabled: dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET || dataType === DATA_TYPES.DEBIT_CREDIT || dataType === DATA_TYPES.OTC_CASHOUT || dataType === DATA_TYPES.PAYOUT_TOP_UP
                                } }
                                dateFormat="DD.MM.YYYY"
                                value={ date || "" }
                                isValidDate={ (event) => this.isDateValid(event) }
                                onChange={ (event) => this.handleDateChange(event) }
                                required={ true }
                              />
                            )}
                          </Column>
                        ) }

                        {(dataType === DATA_TYPES.SETTLEMENT_BY_REQUEST || dataType === DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST) && (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <label> Time / Amount </label>
                            <Select
                              id="settlementId"
                              name="settlementId"
                              value={ controls.settlementId || "" }
                              className={ controls.errors?.has("settlementId") ? "error-field" : "" }
                              required={ true }
                              clearable={ false }
                              disabled={ !controls.updateSettlementDate }
                              onChange={ (value) => this.onValueChange(value, "settlementId") }
                              options={ settlementsForDate }
                            />
                          </Column>
                        )}

                        {(dataType === DATA_TYPES.PAYOUT_TOP_UP || dataType === DATA_TYPES.DEBIT_CREDIT || dataType === DATA_TYPES.OTC_SETTLEMENT || dataType === DATA_TYPES.OTC_CASHOUT_UPDATE) && (
                          <Column
                            flexGrow={ 1 }
                            vertical="start"
                            alignSelf="start"
                            className="input-column"
                          >
                            <span/>
                          </Column>
                        )}
                        { (dataType === DATA_TYPES.SETTLE_AGENT || dataType === DATA_TYPES.OTC_WITHDRAWAL || dataType === DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST || dataType === DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST ) && (
                          <>
                            {[0, 1, 2].map(column => (
                              <Column key={ column } flexGrow={ 1 } className="input-column empty-column">
                                <span />
                              </Column>
                            ))}
                          </>
                        )}

                        <Column flexGrow={ 1 } className="input-column fullwidth-button">
                          <CustomButton
                            title="Filter"
                            type="button"
                            disabled={ lockButton }
                            onClick={ (e) => this.callOnChangeFilter() }
                          />
                        </Column>
                      </Row>
                    </div>
                  )}
                </Panel.Body>
              </Panel>
              {loadingDataInput && (
                <Panel>
                  <Panel.Heading>
                    <Panel.Title>DATA ENTRIES</Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <div
                      style={ {
                        width: "100%",
                        height: "400px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      } }
                    >
                      <Spinner smallContainer={ true } />
                    </div>
                  </Panel.Body>
                </Panel>
              )}
              { (showSecondPanel && !loadingDataInput && dataType === DATA_TYPES.RUNNING_BALANCE) && (
                <Panel>
                  <Panel.Heading>
                    <Panel.Title>DATA ENTRIES</Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <div className="panel-content rb-form" style={ { overflow: "unset" } }>
                      <Row
                        wrap={ true }
                        horizontal="start"
                        vertical="end"
                        className="running-balance-form"
                      >
                        <RunningBalanceComponent
                          items={ runningBalanceTypes }
                          editable={ true }
                          selectedItems={ runningBalanceValues }
                          onTemporaryChange={ this.onTypesTemporaryChange }
                          onChange={ this.onTypesChange }
                        />
                          
                      </Row>
                      {this.checkPageAccess("DATA_INPUT_WRITE") && (
                        <Row
                          flexGrow={ 1 }
                          wrap={ true }
                          horizontal="end"
                          vertical="end"
                          style={ { width: "100%" } }
                        >
                          <Column className="input-column fullwidth-button">
                            <CustomButton
                              title="Save"
                              type="button"
                              onClick={ (e) => this.onSaveDataEntries() }
                            />
                          </Column>
                        </Row>
                      )}
                    </div>
                  </Panel.Body>
                </Panel>
              )}

              {showSecondPanel && !loadingDataInput && dataType !== DATA_TYPES.RUNNING_BALANCE &&
                dataType !== DATA_TYPES.WITHHELD_FUNDS && (
                this.getActionPanel(showThirdPanel ? selectedForm.slice(0, firstPanelLength) : selectedForm,
                  dataType, showThirdPanel ? this.fieldsMap[dataType].slice(0, firstPanelLength) : this.fieldsMap[dataType], settlementMids,
                  !this.isCreditDebit() ? dataType !== DATA_TYPES.OTC_WITHDRAWAL ? 'DATA ENTRIES' : 'OTC DESK' : 'DEBIT MID')
              ) }

              { showThirdPanel && !loadingDataInput && dataType === DATA_TYPES.OTC_SETTLEMENT && (
                this.getActionPanel(selectedForm.slice(firstPanelLength),
                  dataType, this.fieldsMap[dataType].slice(firstPanelLength), selectedForm.slice(firstPanelLength, selectedForm.length - 2),
                  'OTC DESK')
              ) }

              {(showSecondPanel && !loadingDataInput && dataType === DATA_TYPES.WITHHELD_FUNDS) && (
                <WithheldFundsComponent
                  editable={ true }
                  savedData={ savedData }
                  funds={ withheldFunds }
                  writePermission={ this.checkPageAccess("DATA_INPUT_WRITE") }
                  onTemporaryChange={ this.onWithheldTemporaryChange }
                  onChange={ this.onWithheldChange }
                  onSave={ () => this.onSaveDataEntries() }
                />
              )}
            </Column>
          </Row>
        </Column>
        
        <PromptModal
          title="Pay attention"
          message={ promptMessage }
          handleConfirm={ this.handleConfirmPromptModal }
          handleClose={ this.handleClosePromptModal }
          showModal={ showPromptModal }
        />

      </Row>
    );
  }
};

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default connect(mapStateToProps, actions)(ManualInput);
